/* Drawer Cart JS */
/**
 * Get reference to the mini-cart, mini-cart__trigger and overlay DOM
 * elements.
 */
const miniCart = document.querySelector(".mini-cart");
const miniCartTrigger = document.querySelector(".site-header__cart");
const overlay = document.querySelector(".overlay");
const atb = document.querySelector(".button--add-to-bag");
const miniCartClose = document.querySelector(".cart__close");
const miniCartFooter = document.querySelector("#shopify-section-footer");

// Flag to prevent concurrent GWP operations (prevents duplicates and flickering)
let gwpOperationInProgress = false;
const GWP_DISMISSED_VARIANTS_STORAGE_KEY = "gwp_dismissed_variants";

function getDismissedGwpVariants() {
  try {
    const raw = localStorage.getItem(GWP_DISMISSED_VARIANTS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.map((id) => parseInt(id, 10)).filter((id) => Number.isFinite(id));
  } catch (e) {
    return [];
  }
}

function setDismissedGwpVariants(variantIds) {
  try {
    localStorage.setItem(
      GWP_DISMISSED_VARIANTS_STORAGE_KEY,
      JSON.stringify((variantIds || []).map((id) => parseInt(id, 10)).filter((id) => Number.isFinite(id)))
    );
  } catch (e) {}
}

function markGwpAutoAddDismissed(variantId) {
  const parsedVariantId = parseInt(variantId, 10);
  if (!Number.isFinite(parsedVariantId)) return;
  const dismissed = getDismissedGwpVariants();
  if (!dismissed.includes(parsedVariantId)) {
    dismissed.push(parsedVariantId);
    setDismissedGwpVariants(dismissed);
  }
}

function clearGwpAutoAddDismissed(variantId) {
  const parsedVariantId = parseInt(variantId, 10);
  if (!Number.isFinite(parsedVariantId)) return;
  const dismissed = getDismissedGwpVariants().filter((id) => id !== parsedVariantId);
  setDismissedGwpVariants(dismissed);
}

function isGwpAutoAddDismissed(variantId) {
  const parsedVariantId = parseInt(variantId, 10);
  if (!Number.isFinite(parsedVariantId)) return false;
  return getDismissedGwpVariants().includes(parsedVariantId);
}
  
/**
 * When the user clicks the mini-cart__trigger element add classes to the
 * overlay and mini-cart elements to show them.
 */
document.querySelectorAll(".open-window").forEach(function(link) {
  link.addEventListener("click", function(event) {
    event.preventDefault(); // Prevent default link behavior
    window.open(this.href, "_blank", "width=800,height=600,resizable=yes,scrollbars=yes");
  });
});

document.body.addEventListener("click", async (e) => {
  const miniCartTrigger2 = e.target.closest(".site-header__cart"); // Cart icon
  const atb2 = e.target.closest(".button--add-to-bag"); // Add to Bag button

  if (miniCartTrigger2) {
    await openMiniCart();
  }

  if (atb2) {
    setTimeout(() => {
      document.querySelector(".site-header__cart")?.click(); // Simulate click after delay
    }, 2000); // Adjust delay as needed (500ms = 0.5s)
  }
});

async function openMiniCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cartData = await response.json();
    await renderCart(cartData);
    overlay.classList.add("overlay--show");
    miniCart.classList.add("mini-cart--show");
    
    // Prevent body scroll and horizontal scrollbar
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    miniCartFooter.style.display = "none";
  } catch (err) {
    console.error("Cart update failed:", err);
  }
}

/**
 * Handle cart open on Add to Cart Click Button
 */

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (e) {
    const addToBagBtn = e.target.closest(".custom_add_to_bag");

    if (addToBagBtn) {
      e.preventDefault();

      const productId = addToBagBtn.getAttribute("data-product-id");
      const variantId = addToBagBtn.getAttribute("data-variant-id");

      if (!variantId) {
        console.error("No variant selected for this product.");
        return;
      }

      // Prepare the request payload
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      // Send request to Shopify API
      try {
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartData = await response.json();
        // Open the mini cart after adding an item
        setTimeout(() => {
          document.querySelector(".site-header__cart")?.click();
          document.dispatchEvent(new Event('cart:updated'));
        }, 500);
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    }
  });
});
 
// document.addEventListener("DOMContentLoaded", function () {
//   document.body.addEventListener("click", function (e) {
//     const addToCartContainer = e.target.closest(".hidden_add_to_cart");

//     if (addToCartContainer) {
//       e.preventDefault();

//       // Find the button inside the container
//       const button = addToCartContainer.querySelector("button[data-variant-id]");

//       if (!button) {
//         console.error("No button found inside .hidden_add_to_cart");
//         return;
//       }

//       const variantId = button.getAttribute("data-variant-id");

//       if (!variantId) {
//         console.error("No variant selected for this product.");
//         return;
//       }

//       // Prepare the request payload
//       const formData = new FormData();
//       formData.append("id", variantId);
//       formData.append("quantity", 1);

//       // Send request to Shopify API
//       fetch(window.Shopify.routes.root + "cart/add.js", {
//         method: "POST",
//         body: formData,
//       })
//         .then((response) => response.json())
//         .then((cartData) => {
//           console.log("Product added to cart:", cartData);

//           // Open the mini cart after adding an item
//           setTimeout(() => {
//             document.querySelector(".site-header__cart")?.click();
//           }, 500);
//         })
//         .catch((error) => console.error("Error adding to cart:", error));
//     }
//   });
// });


document.body.addEventListener("click", async (e) => {
  const atc = e.target.closest(".product-form__btn");

  if (atc) {
    e.preventDefault();
    const form = atc.closest("form");
    const quantityInput = form.querySelector(".quantity-selector__field");
    const productId = form.getAttribute("data-productid");


    const rebuyParam= new URLSearchParams(window.location.search).get('rq');
    const sessionRebuyId = sessionStorage.getItem("rebuyId");
    const rebuyIdFromParam = rebuyParam && rebuyParam.startsWith('rebuy_') ? rebuyParam.replace('rebuy_', '') : null;
    if (!form) {
      console.error("Add to Cart form not found.");
      return;
    }

    const formData = new FormData(form);
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const productVariantId = formData.get('id');
    if(formData.get('purchase_type') == 'onetime') {
   //   formData.set('selling_plan', '');
formData.delete('selling_plan');

    }
    //selling_plan_bar
    if(formData.get('selling_plan_bar') != null)
    {
      formData.set('selling_plan', formData.get('selling_plan_bar')); 
      formData.set('purchase_type','autodeliver')
    }
    try {
      // Fetch the current cart
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cartData = await cartResponse.json();

      // Check if the product already exists in the cart
   /*   const existingItem = cartData.items.find(
        (item) => item.id == productVariantId
      );
      */
      
      const  existingItem = false;

      if (existingItem) {
        // Update the existing item's quantity
        const updateData = {
          updates: {
            [existingItem.key]: existingItem.quantity + quantity, // Increase quantity
          },
        };

        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });

      } else {
        // Add as a new product if it doesn't exist in cart
        formData.append("quantity", quantity);
        formData.append("product_id", productId);
        if(sessionRebuyId && rebuyIdFromParam && sessionRebuyId === rebuyIdFromParam){
          console.log("Adding to cart with Rebuy ID:", sessionRebuyId);
          formData.append("properties[_widget_source]", "bundle_and_save");
          formData.append("properties[_widget_section]", "bundle_cta");
        }          

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formData).toString(),
        });
        sessionStorage.removeItem("rebuyId");
      }

      // Refresh cart after update
      setTimeout(() => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            renderCart(cartData);
            overlay.classList.add("overlay--show");
            miniCart.classList.add("mini-cart--show");
            miniCartFooter.style.display = "none";
            document.dispatchEvent(new Event('cart:updated'));
          })
          .catch((err) => console.error("Cart update failed:", err));
      }, 800);

    } catch (err) {
      console.error("Cart update failed:", err);
    }
  }
});


/**
 * When the user clicks the overlay element remove classes from the mini-cart
 * and overlay to hide them again.
 */

document.body.addEventListener("click", async (e) => {
  if (e.target.closest(".overlay")) {
    const overlay2 = document.querySelector(".overlay");
    const miniCart2 = document.querySelector(".mini-cart");

    overlay2?.classList.remove("overlay--show");
    miniCart2?.classList.remove("mini-cart--show");
    
    // Restore body and documentElement overflow
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
});

/**
 * When the user clicks the close mini cart button remove classes from the mini-cart.
 */

miniCartClose.addEventListener("click", async () => {
  overlay.classList.remove("overlay--show");
  miniCart.classList.remove("mini-cart--show");
  
  // Restore body and documentElement overflow
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
});

/**
 * Initialize subscription cache and load cart
 */
// Load subscription cache on page load
loadSubscriptionCache();

/**
 * Sends a GET request to the '/{locale}/cart.js' route of the Shopify Ajax
 * API, returns the response as JSON and then passes the data to the
 * renderCart function, which outputs the content.
 */
fetch(window.Shopify.routes.root + "cart.js")
  .then((response) => response.json())
  .then((data) => {
    // Loop through items and attach them to the DOM
    renderCart(data);
  })
  .catch((err) => console.log(err));

let rebuyCarouselHandler = null;

function handleRebuyCarousels(retryCount = 0) {
  const maxRetries = 10;
  const retryDelay = 200;
  
  if (window.Rebuy && window.Rebuy.widgets && window.Rebuy.widgets.length > 0) {
    let widgetsProcessed = 0;
    
    window.Rebuy.widgets.forEach(widget => {
      if (widget.View && widget.View.carousel) {
        // Check if carousel element exists and has proper dimensions
        const carouselElement = widget.View.carousel.element;
        if (carouselElement && carouselElement.offsetHeight > 0) {
          widget.View.carousel.options.adaptiveHeight = true;
          widget.View.carousel.options.resize = true;
          widget.View.carousel.options.watchCSS = true;
          widget.View.carousel.resize();
          widgetsProcessed++;
        }
      }
    });
    
    // If no widgets were processed and we have retries left, try again
    if (widgetsProcessed === 0 && retryCount < maxRetries) {
      setTimeout(() => handleRebuyCarousels(retryCount + 1), retryDelay);
    }
  } else if (retryCount < maxRetries) {
    // Rebuy not ready yet, retry
    setTimeout(() => handleRebuyCarousels(retryCount + 1), retryDelay);
  }
}

// Remove existing listener if it exists and add new one
if (rebuyCarouselHandler) {
  document.removeEventListener('rebuy.init', rebuyCarouselHandler);
}

rebuyCarouselHandler = function() {
  // Use multiple timeouts to catch widgets at different loading stages
  setTimeout(() => handleRebuyCarousels(), 100);
  setTimeout(() => handleRebuyCarousels(), 300);
  setTimeout(() => handleRebuyCarousels(), 500);
};

document.addEventListener('rebuy.init', rebuyCarouselHandler);

/**
 * Determine if an item should be subscribed based on explicit subscription intent
 * rather than just the presence of selling_plan_allocation
 */
function determineSubscriptionState(item) {
  // First check cached subscription states - this should override everything
  const cachedState = getSubscriptionCache(item.key);
  if (cachedState !== null) {
    return cachedState;
  }
  
  // Check for explicit subscription properties from PLP/PDP
  if (item.properties) {
    // Check for 'Subscribe & Save' property set to 'true' (from PLP subscription button)
    if (item.properties['Subscribe & Save'] === 'true') {
      return true;
    }
    
    // Check for 'purchase_type' set to 'autodeliver' (from PDP subscription button)
    if (item.properties['purchase_type'] === 'autodeliver') {
      return true;
    }
    
    // Check for delivery interval property (indicates subscription intent)
    if (item.properties['Delivery'] && item.properties['purchase_type'] !== 'onetime') {
      return true;
    }
  }
  
  // Check for selling plan allocation (PDP subscription indicator)
  if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
    const sellingPlan = item.selling_plan_allocation.selling_plan;
    
    // Check if the selling plan name indicates subscription (contains delivery interval)
    if (sellingPlan.name && (
      sellingPlan.name.toLowerCase().includes('delivery') ||
      sellingPlan.name.toLowerCase().includes('days') ||
      sellingPlan.name.toLowerCase().includes('weeks') ||
      sellingPlan.name.toLowerCase().includes('months') ||
      sellingPlan.name.toLowerCase().includes('subscribe') ||
      sellingPlan.name.toLowerCase().includes('recurring')
    )) {
      return true;
    }
    
    // Additional check: if selling plan has a discount, it's likely a subscription
    if (item.selling_plan_allocation.per_delivery_price < item.price) {
      return true;
    }
  }
  
  // Handle edge case: Item shows discount but missing selling_plan_allocation
  // This can happen when items are merged or data is inconsistent
  // Check if the current price suggests it's discounted (approximately 80% of original)
  if (item.price && item.original_price && item.price < item.original_price) {
    const discountRatio = item.price / item.original_price;
    // If discount is approximately 20% (price is 80% of original), it's likely a subscription
    if (discountRatio >= 0.75 && discountRatio <= 0.85) {
      return true;
    }
  }
  
  return false;
}

/* Get cached subscription state for an item*/

function getSubscriptionCache(itemKey) {
  if (!window.subscriptionCache) {
    window.subscriptionCache = {};
  }
  // Check if the key exists in cache - return the actual value (including false)
  if (itemKey in window.subscriptionCache) {
    return window.subscriptionCache[itemKey];
  }
  return null;
}

/**
 * Set cached subscription state for an item
 */
function setSubscriptionCache(itemKey, isSubscribed) {
  if (!window.subscriptionCache) {
    window.subscriptionCache = {};
  }
  window.subscriptionCache[itemKey] = isSubscribed;
  
  // Also store in localStorage for persistence across page refreshes
  try {
    const cache = JSON.parse(localStorage.getItem('cart_subscription_cache') || '{}');
    cache[itemKey] = isSubscribed;
    localStorage.setItem('cart_subscription_cache', JSON.stringify(cache));
  } catch (e) {
    console.warn('Failed to save subscription cache to localStorage:', e);
  }
}

/**
 * Load subscription cache from localStorage
 */
function loadSubscriptionCache() {
  try {
    const cache = JSON.parse(localStorage.getItem('cart_subscription_cache') || '{}');
    window.subscriptionCache = cache;
  } catch (e) {
    console.warn('Failed to load subscription cache from localStorage:', e);
    window.subscriptionCache = {};
  }
}

/**
 * Add event listeners for subscription functionality
 */
function addSubscriptionEventListeners() {
  // Prevent multiple event listeners
  if (window.subscriptionEventListenersAdded) return;
  window.subscriptionEventListenersAdded = true;
  
  // Use event delegation for subscription checkboxes and dropdowns
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('subscribe-save-checkbox')) {
      handleSubscribeToggle(event.target);
    } else if (event.target.classList.contains('subscribe-dropdown')) {
      handleIntervalChange(event.target);
    }
  });
}

/**
 * Handle subscription toggle checkbox
 */
async function handleSubscribeToggle(checkbox) {
  const itemKey = checkbox.dataset.lineKey;
  const isChecked = checkbox.checked;

  //quantity param
  const cartItem = checkbox.closest('.mini-cart__item');
  const quantityInput = cartItem ? cartItem.querySelector('.item__quantity') : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  
  // Update cache immediately
  setSubscriptionCache(itemKey, isChecked);
  
  // Update UI
  const dropdownWrap = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-dropdown-wrap');
  const textSpan = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-text');
  
  if (isChecked) {
    dropdownWrap.style.display = 'block';
    textSpan.innerHTML = 'Subscribed';
    
    // Get the selected interval and update the cart with selling plan
    const dropdown = dropdownWrap.querySelector('.subscribe-dropdown');
    if (dropdown && dropdown.value) {
      await handleIntervalChange(dropdown);
    }
  } else {
    dropdownWrap.style.display = 'none';
    textSpan.innerHTML = 'Subscribe & Save <span class="subscribe-save-discount">15%</span>';
    
    // Remove selling plan from cart item
    try {
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: '',
          quantity: quantity
        })
      });
      
      if (updateResponse.ok) {
        // Trigger cart update
        if (window.refreshCart) {
          window.refreshCart();
        }
      }
    } catch (error) {
      console.error('Error removing selling plan:', error);
    }
  }
}

/**
 * Handle interval change dropdown
 */
async function handleIntervalChange(select) {
  const itemKey = select.dataset.lineKey;
  const selectedValue = select.value;
  const cartItem = select.closest('.mini-cart__item');
  const quantityInput = cartItem ? cartItem.querySelector('.item__quantity') : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  
  if (!cartItem) return;
  
  let sellingPlanId = null;
  
  // Check if the selected value is already a selling plan ID (numeric)
  if (/^\d+$/.test(selectedValue)) {
    // Value is already a selling plan ID, use it directly
    sellingPlanId = parseInt(selectedValue);
  } else {
    // Value is interval text, check if we have the selling plan ID in data attribute
    const selectedOption = select.querySelector(`option[value="${selectedValue}"]`);
    if (selectedOption && selectedOption.dataset.sellingPlanId) {
      sellingPlanId = parseInt(selectedOption.dataset.sellingPlanId);
    } else {
      // Fallback: find the selling plan ID by matching interval text
      try {
        const productHandle = cartItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
        if (!productHandle) return;
        
        // Fetch product data to get selling plan ID
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) return;
        
        const productData = await response.json();
        
        // Find the selling plan that matches the new interval
        if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
          for (const group of productData.selling_plan_groups) {
            if (group.selling_plans) {
              for (const plan of group.selling_plans) {
                if (plan.name && plan.name.toLowerCase().includes(selectedValue.toLowerCase().replace(' days', ''))) {
                  sellingPlanId = plan.id;
                  break;
                }
              }
              if (sellingPlanId) break;
            }
          }
        }
      } catch (error) {
        console.error('Error finding selling plan for interval:', error);
        return;
      }
    }
  }
  
  if (sellingPlanId) {
    // Update the cart item with the new selling plan
    try {
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: sellingPlanId,
          quantity: quantity
        })
      });
      
      if (updateResponse.ok) {
        // Trigger cart update
        if (window.refreshCart) {
          window.refreshCart();
        }
      }
    } catch (error) {
      console.error('Error updating cart with selling plan:', error);
    }
  }
}

/**
 * Clear subscription cache for removed items
 */
function cleanupSubscriptionCache(currentItems) {
  if (!window.subscriptionCache) return;
  
  const currentKeys = currentItems.map(item => item.key);
  const cacheKeys = Object.keys(window.subscriptionCache);
  
  // Remove cache entries for items no longer in cart
  cacheKeys.forEach(key => {
    if (!currentKeys.includes(key)) {
      delete window.subscriptionCache[key];
    }
  });
  
  // Update localStorage
  try {
    localStorage.setItem('cart_subscription_cache', JSON.stringify(window.subscriptionCache));
  } catch (e) {
    console.warn('Failed to update subscription cache in localStorage:', e);
  }
}

function parseBonusOfferPercentFromProperty(bonusOfferProp) {
  if (bonusOfferProp == null || bonusOfferProp === '') return null;
  const m = String(bonusOfferProp).match(/(\d+(?:\.\d+)?)\s*%/);
  if (!m) return null;
  const n = parseFloat(m[1], 10);
  if (!Number.isFinite(n) || n <= 0 || n >= 100) return null;
  return n;
}

function getBonusOfferPriceDisplayAmounts(item) {
  if (!item || !item.properties || !item.properties['Bonus Offer']) return null;

  const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
  const bonusPct = parseBonusOfferPercentFromProperty(item.properties['Bonus Offer']);
  const props = item.properties || {};
  const propOrigUnitCents = props['_bonus_original_cents'] != null ? Number(props['_bonus_original_cents']) : null;
  const propDiscountedUnitCents = props['_bonus_discounted_cents'] != null ? Number(props['_bonus_discounted_cents']) : null;

  // Preferred source: exact values from the upsell card itself.
  if (
    Number.isFinite(propOrigUnitCents) &&
    Number.isFinite(propDiscountedUnitCents) &&
    propOrigUnitCents > 0 &&
    propDiscountedUnitCents > 0 &&
    propDiscountedUnitCents <= propOrigUnitCents
  ) {
    return {
      discountedTotal: (propDiscountedUnitCents * qty) / 100,
      originalTotal: (propOrigUnitCents * qty) / 100,
    };
  }

  const origLine =
    item.original_line_price != null && item.original_line_price !== ''
      ? Number(item.original_line_price)
      : item.original_price != null
        ? Number(item.original_price) * qty
        : null;
  const finalLine =
    item.final_line_price != null && item.final_line_price !== '' ? Number(item.final_line_price) : null;

  if (origLine != null && finalLine != null && finalLine < origLine) {
    return { discountedTotal: finalLine / 100, originalTotal: origLine / 100 };
  }

  if (item.discounted_price != null && item.original_price != null) {
    const d = Number(item.discounted_price);
    const o = Number(item.original_price);
    if (d < o) {
      return { discountedTotal: (d * qty) / 100, originalTotal: (o * qty) / 100 };
    }
  }

  const oPrice = item.original_price != null ? Number(item.original_price) : null;
  const iPrice = item.price != null ? Number(item.price) : null;
  if (oPrice != null && iPrice != null && iPrice < oPrice) {
    return { discountedTotal: (iPrice * qty) / 100, originalTotal: (oPrice * qty) / 100 };
  }

  if (bonusPct != null && oPrice != null) {
    const unitSaleCents = Math.round((oPrice * (100 - bonusPct)) / 100);
    return {
      discountedTotal: (unitSaleCents * qty) / 100,
      originalTotal: (oPrice * qty) / 100,
    };
  }

  if (item.handle && window.productVariantPriceCache) {
    const cacheKey = `${item.handle}_${item.variant_id}`;
    const cachedUnitDollars = window.productVariantPriceCache[cacheKey];
    if (bonusPct != null && typeof cachedUnitDollars === 'number' && cachedUnitDollars > 0) {
      const unitOrigCents = Math.round(cachedUnitDollars * 100);
      const unitSaleCents = Math.round((unitOrigCents * (100 - bonusPct)) / 100);
      return {
        discountedTotal: (unitSaleCents * qty) / 100,
        originalTotal: (unitOrigCents * qty) / 100,
      };
    }
  }

  return null;
}

function getNonBundleLineSubtotalCents(item, isGwpItem) {
  if (!item || isGwpItem) return 0;

  // Keep subtotal in sync with visible bonus-offer discounted pricing.
  if (item.properties && item.properties['Bonus Offer']) {
    const bonusAmounts = getBonusOfferPriceDisplayAmounts(item);
    if (bonusAmounts && Number.isFinite(bonusAmounts.discountedTotal)) {
      return Math.round(bonusAmounts.discountedTotal * 100);
    }
  }

  if (item.final_line_price != null && item.final_line_price !== '') {
    const finalLine = Number(item.final_line_price);
    if (Number.isFinite(finalLine)) return finalLine;
  }

  const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
  if (item.price != null && item.price !== '') {
    const unit = Number(item.price);
    if (Number.isFinite(unit)) return unit * qty;
  }

  if (item.original_price != null && item.original_price !== '') {
    const original = Number(item.original_price);
    if (Number.isFinite(original)) return original * qty;
  }

  return 0;
}

/**
 * Outputs cart items and content in the DOM.
 */
async function renderCart(data) {
  // Prevent concurrent renderCart calls - this fixes duplicate items issue
  if (window.renderCartLock) {
    //console.log('[renderCart] Blocked concurrent render call');
    return;
  }
  window.renderCartLock = true;
  var cartDataForBonusOffer = null;

  try {
    // Load subscription cache from localStorage
    loadSubscriptionCache();
    
    // Add CSS for eligibility
    addEligibilityCSS();
    
    // Add event listeners for subscription functionality
    addSubscriptionEventListeners();
    
    // Add missing properties (GWP, Final Sale) to cart items
    const cartDataWithProperties = await addMissingProperties(data);
    cartDataForBonusOffer = cartDataWithProperties;
    
    // Clean up subscription cache for removed items
    cleanupSubscriptionCache(cartDataWithProperties.items);

    // Get DOM element where the cart items will be attached
    const miniCartItems = document.querySelector(".mini-cart__items");
    const subtotalPrice = document.querySelector(".subtotal-price");
    const totalCartItems = document.querySelector(".total__cart__items");
    const miniCartSummary = document.querySelector(".mini-cart__summary");
    const checkoutButton = document.querySelector(".cart__checkout");
    const productSlider = document.querySelector(".product-slider");
    const miniCartSlider = document.querySelector("#mini-cart-carousel");
    const shippingCalculator = document.querySelector(".shipping-calculator-wrap");
    
    const miniCartSliderHeading = document.querySelector(
      ".product-slider-heading"
    );
    const klarnaPlacement = document.querySelector(".cart_klarna");
    const cartCount = document.querySelector(".nav__cart-count span");
    let cartItemsIds = cartDataWithProperties.items.map((e) => e.product_id);
    // Clear HTML in the mini cart items
    if (miniCartItems) miniCartItems.innerHTML = "";
    let subtotal = 0;
    let totalItems = 0;

  // Loop through cart items and attach them to the mini-cart__items element
  if (cartDataWithProperties.items.length > 0) {
    

    for (const item of cartDataWithProperties.items) {
      

      const actualPrice = item?.selling_plan_allocation?.per_delivery_price ? item?.selling_plan_allocation?.per_delivery_price : item.original_price;
      const originalPrice = actualPrice * item.quantity;

      const size = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "size"
      )?.value;
      const color = item.options_with_values.find(
        (opt) =>
          opt.name.toLowerCase() === "color" ||
          opt.name.toLowerCase() === "colour"
      )?.value;
      const width = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "width"
      )?.value;
      let sizeAndColor = [size, color, width].filter(Boolean).join(" | ");

      // Check if item is GWP (Gift With Purchase)
      const isGwpItem = item.properties && (
        item.properties["Note"] && item.properties["Note"].includes("GWP") || 
        item.properties["note"] && item.properties["note"].includes("GWP") || 
        item.properties.Note && item.properties.Note.includes("GWP") || 
        item.properties["_Note"] && item.properties["_Note"].includes("GWP") ||
        item.properties["_gwp_nc"] === "1" || 
        item.properties["_gift_for_purchase"] === "true"
      );

      // Check if this is a bundle item
      // const isBundleItem = item.properties && item.properties._bundle_type === 'custom_set';
       const isBundleItem = item.properties && item.properties._bundle_type && item.properties._bundle_type.startsWith('custom_set');

      // Only add to subtotal if NOT a GWP item and NOT a bundle item (bundle handled separately)
      if (!isGwpItem && !isBundleItem) {
        subtotal += getNonBundleLineSubtotalCents(item, isGwpItem);
        totalItems += item.quantity;
      } else if (!isBundleItem) {
        // GWP items still count towards item count
        totalItems += item.quantity;
      }
      // Bundle items: subtotal and totalItems already handled in bundle block above
      const disableMinQuantity = (item.quantity  == 1) ? 'disabled' : '';
      // Hide quantity selector for GWP items
      const hideQuantityForGwp = isGwpItem ? 'style="display: none;"' : '';
      let productTitle = item.product_title;
      //productTitle = productTitle.replace(/Lip Oasisᵀᴹ/g, 'lip oasis<sup>TM</sup>');
      let sellingPlanHTML = '';
      if(item.selling_plan_allocation){
          // sellingPlanHTML = `<div class="opacity-60">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }
      let saleTagHtml = '';
      if (item.properties && (item.properties["Note"] === "Final Sale" || item.properties["_Note"] === "Final Sale")) {
         saleTagHtml =`<span class="sale-cart-tag item-property badge sale-badge" style="visibility: hidden;">Final Sale</span>`;
      } else {
      }
      // let gwpTagHtml = '';
      // if (isGwpItem) {
      //   gwpTagHtml +=`<span class="sale-cart-tag item-property badge gwp-badge" style="font-size: 11px; margin-left: 0; display: inline-block; vertical-align: middle; padding: 4px 10px 2px;">Discount applied at next step</span>`;
      // }
      let bonusOfferTagHtml = '';
      let bonusOfferTagDataAttr = '';
      if (!isGwpItem && item.properties && item.properties['Bonus Offer']) {
        const bonusLabel = item.properties['Bonus Offer'];
        bonusOfferTagHtml = `<span class="sale-cart-tag item-property badge bonus-offer-badge" style="font-size: 10px; top: -3px; padding: 4px 5px 2px;">Bonus offer: ${bonusLabel}</span>`;
        bonusOfferTagDataAttr = ` data-bonus-offer-html="${encodeURIComponent(bonusOfferTagHtml)}"`;
      }

      let priceDisplayHtml = '';
      let priceDataAttr = '';
      let bonusPriceDataAttr = '';
      let trueOriginalPrice = null;
      if (isGwpItem) {
        priceDisplayHtml = `
          <span class="free-price" style="color: #000000;">FREE GIFT</span><br>
          <span class="original-price" style="text-decoration: line-through; color: #999;">$${((originalPrice) / 100).toFixed(2)}</span>
        `;
        // Add data attribute to mark this as GWP item for protection
        priceDataAttr = ' data-gwp-item="true" data-gwp-price-html="' + 
          encodeURIComponent(priceDisplayHtml.replace(/\s+/g, ' ').trim()) + '"';
      } else if (item.selling_plan_allocation) {
        let trueOriginalUnitPrice = null;
        
        // Try to get true original price from product data cache
        if (window.productVariantPriceCache && item.handle) {
          const cacheKey = `${item.handle}_${item.variant_id}`;
          trueOriginalUnitPrice = window.productVariantPriceCache[cacheKey];
        }
        
        if (trueOriginalUnitPrice) {
          // Use the true original price from cache
          const discountedTotal = (item.selling_plan_allocation.per_delivery_price * item.quantity) / 100;
          const originalTotal = trueOriginalUnitPrice * item.quantity;
          priceDisplayHtml = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
          priceDataAttr = ` data-original-price="$${trueOriginalUnitPrice.toFixed(2)}"`;
        } else {
          // Fallback: use current logic while we fetch the true price
          const discountedTotal = (item.selling_plan_allocation.per_delivery_price * item.quantity) / 100;
          const originalTotal = (item.original_price * item.quantity) / 100;
          priceDisplayHtml = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
          priceDataAttr = ` data-original-price="$${(item.original_price / 100).toFixed(2)}"`;
          
          // Fetch the true original price for future use
          if (item.handle) {
            fetch(`/products/${item.handle}.js`)
              .then(res => res.json())
              .then(productData => {
                const variant = productData.variants.find(v => v.id == item.variant_id);
                if (variant) {
                  if (!window.productVariantPriceCache) window.productVariantPriceCache = {};
                  const cacheKey = `${item.handle}_${item.variant_id}`;
                  window.productVariantPriceCache[cacheKey] = variant.price / 100;
                }
              })
              .catch(error => {
                // Silently fail, we have fallback pricing
              });
          }
        }
      } else if (!isGwpItem && item.properties && item.properties['Bonus Offer']) {
        const bonusAmounts = getBonusOfferPriceDisplayAmounts(item);
        if (bonusAmounts) {
          const discountedTotal = bonusAmounts.discountedTotal;
          const originalTotal = bonusAmounts.originalTotal;
          priceDisplayHtml = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price" style="text-decoration: line-through; color: #999;">$${originalTotal.toFixed(2)}</span>`;
          bonusPriceDataAttr =
            ' data-bonus-price-html="' +
            encodeURIComponent(priceDisplayHtml.replace(/\s+/g, ' ').trim()) +
            '"';
          priceDataAttr = '';
        } else {
          const total = (item.price * item.quantity) / 100;
          priceDisplayHtml = `<span class="discounted-price">$${total.toFixed(2)}</span>`;
          priceDataAttr = '';
        }
      } else {
        // For regular items, show normal price
        const total = (item.price * item.quantity) / 100;
        priceDisplayHtml = `<span class="discounted-price">$${total.toFixed(2)}</span>`;
        priceDataAttr = '';
      }
      // Only inject Subscribe & Save UI for eligible items (async check)
      let subscribeSaveHtml = '';
      const eligible = false;
      // Build dynamic dropdown options if eligible
      let dropdownHtml = ''; 
      if (eligible) {
        const intervalOptions = (productDataCache[item.handle] && productDataCache[item.handle].intervalOptions) || [];
        
        // Debug: Log interval options for troubleshooting
        if (item.properties && item.properties['Delivery']) {
          intervalOptions.forEach(opt => {
            const optionInterval = opt.label.replace(/\s*Delivery\s*/i, '').trim();
          });
        }
        
        dropdownHtml = intervalOptions.length
        ? `<select class="subscribe-dropdown" data-line-key="${item.key}" style="width: 100%;">${
            intervalOptions
              .map((opt) => {
                let isSelected = false;

                // 🔹 Normalize label → interval text (e.g. "Delivery every 45 days" -> "45 Days")
                const rawLabel = opt.label || "";
                let intervalText = rawLabel
                  .replace(/\bdelivery\b/i, "")
                  .replace(/\bevery\b/i, "")
                  .trim();

                const match = intervalText.match(/(\d+)\s*days?/i);
                if (match) {
                  intervalText = `${match[1]} Days`;
                }

                if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                  isSelected =
                    String(item.selling_plan_allocation.selling_plan.id) ===
                    String(opt.value);
                }
                else if (item.properties && item.properties["Delivery"]) {
                  const propInterval = String(item.properties["Delivery"]).trim();
                  isSelected = propInterval === intervalText;
                }

                return `<option value="${opt.value}" data-interval="${intervalText}"${
                  isSelected ? " selected" : ""
                }>${intervalText}</option>`;
              })
              .join("")
          }</select>`
        : "";
        const shouldBeSubscribed = determineSubscriptionState(item);
        
        subscribeSaveHtml = `
          <div class="subscribe-save-cart-ui">
            <label class="subscribe-save-label">
              <input type="checkbox" class="subscribe-save-checkbox" data-line-key="${item.key}" data-variant-id="${item.variant_id}:${item.key}"${shouldBeSubscribed ? ' checked' : ''}>
              <span class="subscribe-save-text">
                ${shouldBeSubscribed ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount">15%</span>'}
              </span>
            </label>
            <div class="subscribe-save-dropdown-wrap" style="${shouldBeSubscribed ? '' : 'display: none;'} margin-top: 5px;">
              ${dropdownHtml}
            </div>
          </div>
        `;
        
      } else {
        // console.log('NOT setting subscribeSaveHtml for', item.handle, '- keeping empty string');
      }
      
      const eligibilityAttribute = eligible ? 'data-subscription-eligible="true"' : 'data-subscription-eligible="false"';
      
      // Check if this is a bundle item
      // const isBundle = item.properties && item.properties._bundle_type === 'custom_set';
      const isBundle = item.properties && item.properties._bundle_type && item.properties._bundle_type.startsWith('custom_set');

      const isShopRoutine =
        item.properties &&
        (item.properties._shop_routine === '1' ||
          item.properties._shop_routine === 'true' ||
          item.properties._shop_routine === true) &&
        !isBundle;

      const isBonusUpsellLineItem =
        item.properties &&
        (item.properties['_bonus-upsell-line-item'] === 'true' ||
          item.properties['_bonus-upsell-line-item'] === true ||
          item.properties['_bonus-upsell-line-item'] === '1');
      const bonusUpsellAttribute = isBonusUpsellLineItem ? 'data-bonus-upsell-line-item="true"' : '';
      
      let itemHtml;
      
      if (isBundle) {
        // Custom bundle template
        const bundleImage = item.properties._bundle_image || item.featured_image.url;
        const bundleTitle = item.properties._bundle_title || 'Custom Bundle';
        const bundleSubtitle = item.properties._bundle_subtitle || 'Custom set';
        
        // Calculate actual bundle total from all variants
        let calculatedBundleTotal = 0;
        try {
          const bundleVariants = JSON.parse(item.properties._bundle_variants);
          calculatedBundleTotal = bundleVariants.reduce((sum, v) => sum + v.price, 0);
        } catch (e) {
          // Fallback to item price if parsing fails
          calculatedBundleTotal = item.final_line_price;
        }
        
        const bundleTotal = `$${(calculatedBundleTotal / 100).toFixed(2)}`;
        const bundleCount = item.properties._bundle_count || `${item.quantity} items`;
        const bundleProducts = item.properties._bundle_products || 'Bundle items';
        
        // Add bundle total to subtotal (not the single item price)
        subtotal += calculatedBundleTotal;
        totalItems += 1; // Bundle counts as 1 item in cart
        
        itemHtml = `
          <div class="mini-cart__item bundle-item" ${eligibilityAttribute} ${bonusUpsellAttribute} data-line-key="${item.key}">
            <div class="bundle-layout" style="display: flex; gap: 12px; align-items: flex-start;">
              <div class="bundle-image" style="flex-shrink: 0;">
                <img src="${bundleImage}" alt="Bundle" class="item__image" style="width: 80px; height: 80px; object-fit: cover;" />
              </div>
              <div class="bundle-details" style="flex-grow: 1;">
                <h3 class="product-title" style="margin: 0 0 4px 0; font-size: 14px; font-weight: 600;">${bundleTitle}</h3>
                <p class="bundle-subtitle">${bundleSubtitle}</p>
                <p class="product-price" style="margin: 0 0 8px 0; font-size: 16px; font-weight: 600;">${bundleTotal}</p>
                <p class="bundle-description">
                  <span class="bundle-count">${bundleCount}:</span>
                  <span class="bundle-products">${bundleProducts}</span>
                </p>
              </div>
              <div class="bundle-actions" style="flex-shrink: 0;">
                <button class="item__remove" data-line-key="${item.key}" style="background: none; border: none; cursor: pointer; padding: 4px;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" fill="transparent" stroke="currentColor" class="icon" style="width: 20px; height: 20px;">
                    <path d="M4 6h12" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.5 9v5M11.5 9v5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 6 6 17h8l.5-11" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 6V5c0-1 .75-2 2-2s2 1 2 2v1" stroke-width="1.25"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="error-message"></div>
          </div>
        `;
        } else if (isShopRoutine) {
        const routineTitle =
          (item.properties && (item.properties._routine_title || item.properties['Routine title'])) ||
          productTitle;
        const routineSubtitle =
          (item.properties && (item.properties._routine_subtitle || item.properties['Routine subtitle'])) ||
          'Routine';
        const routineImg =
          item.featured_image && item.featured_image.url ? item.featured_image.url : '';
        const routineImgAlt =
          (item.featured_image && item.featured_image.alt) || routineTitle || '';

        itemHtml = `
          <div class="mini-cart__item shop-routine-item" ${eligibilityAttribute} ${bonusUpsellAttribute} data-line-key="${item.key}">
            <div class="bundle-layout" style="display: flex; gap: 12px; align-items: flex-start;">
              <div class="bundle-image" style="flex-shrink: 0;">
                ${routineImg ? `<a href="${item.url}" class="item__image-link"><img src="${routineImg}" alt="${routineImgAlt}" class="item__image" style="width: 80px; height: 80px; object-fit: cover;" /></a>` : ''}
              </div>
              <div class="bundle-details" style="flex-grow: 1; min-width: 0;">
                <h3 class="product-title" style="margin: 0 0 4px 0; font-size: 14px; font-weight: 600;"><a href="${item.url}" class="no-underline">${routineTitle}</a></h3>
                <p class="bundle-subtitle" style="margin: 0 0 6px 0; font-size: 12px; color: #6b7280;">${routineSubtitle}</p>
                <div>
                  <p class="product-price"${priceDataAttr}${bonusOfferTagDataAttr}${bonusPriceDataAttr} style="margin: 0 0 8px 0;">
                    ${priceDisplayHtml}
                    ${saleTagHtml}
                    ${bonusOfferTagHtml}
                  </p>
                </div>
                <p class="product-size" style="margin: 0 0 8px 0;">${sizeAndColor}</p>
                ${sellingPlanHTML}
                ${item.selling_plan_allocation ? `<input type='hidden' data-selling-plan value='${item.selling_plan_allocation.selling_plan.id}'>` : ''}
                <div class="price__and__quantity">
                  <div class="item__actions">
                    <div class="quantity-input" ${hideQuantityForGwp}>
                      <button type="button" class="minus quantity-selector__action  ${disableMinQuantity}" ${disableMinQuantity}>-</button>
                      <input type="hidden" class="item__line-key" value="${item.key}" />
                      <input type="text" class="item__quantity" min="1" value="${item.quantity}" />
                      <button type="button" class="plus">+</button>
                    </div>
                    <button class="item__remove" data-line-key="${item.key}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" fill="transparent" stroke="currentColor" class="icon"><path d="M4 6h12" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 9v5M11.5 9v5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 6 6 17h8l.5-11" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6V5c0-1 .75-2 2-2s2 1 2 2v1" stroke-width="1.25"/></svg></button>
                  </div>
                  ${subscribeSaveHtml}
                </div>
              </div>
            </div>
            <div class="error-message"></div>
          </div>
        `;
      } else {
        // Regular item template
        itemHtml = `
          <div class="mini-cart__item" ${eligibilityAttribute} ${bonusUpsellAttribute} data-line-key="${item.key}">
            <a href="${item.url}" class="item__image-link">
              <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" class="item__image" />
            </a>
            <div class="item__info">
              <h3 class="product-title"><a href="${item.url}">${productTitle}</a></h3>
            <div>
            <p class="product-price"${priceDataAttr}${bonusOfferTagDataAttr}${bonusPriceDataAttr}>
              ${priceDisplayHtml}
            ${saleTagHtml}
            ${/* gwpTagHtml */''}
            ${bonusOfferTagHtml}
            </p>
        </div>
     <p class="product-size"> ${sizeAndColor}
     </p>
      ${item.variant_id === 46936252416257 ? `<p class="gwp-line-item" style="font-size: 12px; text-transform: uppercase; margin-top: 10px;">Free with orders above: $100</p>` : ''}
      ${sellingPlanHTML}
      ${item.selling_plan_allocation ? `<input type='hidden' data-selling-plan value='${item.selling_plan_allocation.selling_plan.id}'>` : ''}
     <div class="price__and__quantity">
      <div class="item__actions">
           <div class="quantity-input" ${hideQuantityForGwp}>
              <button type="button" class="minus quantity-selector__action  ${disableMinQuantity}" ${disableMinQuantity}>-</button>
              <input type="hidden" class="item__line-key" value="${item.key}" />
              <input type="text" class="item__quantity" min="1" value="${
                item.quantity
              }" />
              <button type="button" class="plus">+</button>
           </div>
           <button class="item__remove" data-line-key="${
             item.key
           }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" fill="transparent" stroke="currentColor" class="icon"><path d="M4 6h12" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 9v5M11.5 9v5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 6 6 17h8l.5-11" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6V5c0-1 .75-2 2-2s2 1 2 2v1" stroke-width="1.25"/></svg>
           </button>
        </div>
        ${subscribeSaveHtml}
     </div>
    <div class="error-message"></div>
  </div>
  </div>
        `;
      }
      miniCartItems.innerHTML += itemHtml;
      
      // Bundle functionality removed - keeping products simple

      // Update values
      if (subtotalPrice)
        subtotalPrice.textContent = `$${(subtotal / 100).toFixed(2)}`;
      if (totalCartItems) {
        totalCartItems.textContent =
          totalItems > 1
            ? `SHOPPING CART (${totalItems} ITEMS)`
            : `SHOPPING CART (${totalItems} ITEM)`;
      }


      // Update Klarna `data-purchase-amount`
    if (klarnaPlacement) {
      klarnaPlacement.setAttribute("data-purchase-amount", subtotal);
    }

    // Update the cart count in the header
    if (cartCount) {
      cartCount.textContent = totalItems;
    }

      // Show mini-cart summary and checkout button
      [
        miniCartSummary,
        checkoutButton,
        productSlider,
        miniCartSlider,
        miniCartSliderHeading,
        shippingCalculator
      ].forEach((el) => {
        if (el) el.style.display = "block";
      });
    };
    // Set global cart data for subscribe-save-cart-ui.js
    window.cartData = cartDataWithProperties;
    // Dispatch event to inject Subscribe & Save UI
    document.dispatchEvent(new Event('subscribe-save-inject'));
    var slideItems = document.getElementsByClassName("product-cart-slider");
    for (var j = 0; j < slideItems.length; j++) {
      slideItems[j].classList.remove("disable");
    }
    for (var i = 0; i < cartItemsIds.length; i++) {
      var elementClass = "cart-product-recommend-slider-" + cartItemsIds[i];
      var element = document.getElementsByClassName(elementClass);

      if (element.length != 0) {
        element[0].classList.add("disable");
      }
    }
    const miniCartBottom = document.querySelector('.mini-cart-bottom');
    const cartItemsContent = document.querySelector('.cart-grid-items-wrap');
    if (miniCartBottom && cartItemsContent) {
            const updatePadding = () => {
        const height = miniCartBottom.getBoundingClientRect().height;
        cartItemsContent.style.paddingBottom = `${height + 10}px`;
      };
      updatePadding();
      const resizeObserver = new ResizeObserver(() => {
        updatePadding();
      });
      resizeObserver.observe(miniCartBottom);
      document.addEventListener('cart:updated', () => {
        setTimeout(updatePadding, 50);
      });
    }
  } else {
    miniCartItems.innerHTML =
      '<div class="mini-cart__empty"><img src="https://theoutset.com/cdn/shop/files/logo.svg?v=1676481590" alt="logo" /><p>You have no items in your cart</p><a href="/"><button class="mini-cart__empty__button">Continue Shopping</button></a></div>';
    if (subtotalPrice) subtotalPrice.textContent = "$0.00";
    if (totalCartItems) totalCartItems.textContent = `YOUR CART`;

     // Update Klarna `data-purchase-amount`
     if (klarnaPlacement) {
      klarnaPlacement.setAttribute("data-purchase-amount", "0");
    }

    // Reset cart count in the header
    if (cartCount) {
      cartCount.textContent = "0";
    }

    // Hide mini-cart summary and checkout button
    [
      miniCartSummary,
      checkoutButton,
      productSlider,
      miniCartSlider,
      miniCartSliderHeading,
      shippingCalculator
    ].forEach((el) => {
      if (el) el.style.display = "none";
    });
  }

    // Calculate subtotal for shipping calculator based on displayed prices (includes manual subscription discounts)
    function calculateDisplayedSubtotal() {
      let displayedSubtotal = 0;
      const cartItems = document.querySelectorAll('.mini-cart__item');
      
      cartItems.forEach(item => {
        const priceElement = item.querySelector('.product-price');
        
        // Check if item is GWP (Gift With Purchase) - exclude from shipping calculation
        // Check for data-gwp-item attribute and free-price element first (most reliable)
        const isGwpItem = priceElement && (
          priceElement.getAttribute('data-gwp-item') === 'true' ||
          priceElement.querySelector('.free-price') !== null
        ) || item.querySelector('.gwp-badge') || 
           item.querySelector('[class*="gwp"]') ||
           item.textContent.includes('GWP') ||
           item.textContent.includes('Discount applied at next step');
        
        if (!isGwpItem) {
          if (priceElement) {
            const priceSpan = priceElement.querySelector('.discounted-price');
            if (priceSpan) {
              const priceText = priceSpan.textContent.trim();
              const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
              if (priceMatch) {
                const amount = parseFloat(priceMatch[1].replace(',', ''));
                displayedSubtotal += amount;
              }
            }
          }
        }
      });
      
      return displayedSubtotal * 100; // Convert to cents for consistency with original subtotal
    }

    // Use displayed subtotal for shipping calculator after DOM is updated
    // Skip if GWP operation is in progress to prevent subtotal fluctuation
    setTimeout(() => {
      if (window.gwpOperationInProgress) {
        return;
      }
      
      const displayedSubtotal = calculateDisplayedSubtotal();
      
      // Update unified progress bar with both shipping and gift milestones
      updateUnifiedProgressBar(displayedSubtotal, cartDataWithProperties);
      // Apply gwp-none on GWP line items when milestone is not met
      if (typeof applyGwpNoneClass === 'function') applyGwpNoneClass(cartDataWithProperties);
    }, 100);

    document.querySelectorAll(".cart-rebuy-slider").forEach((element) => {
      const goal = element.getAttribute('data-goal');
      if(goal <= subtotal) element.classList.remove("hidden");
      else element.classList.add("hidden");
    });
    document.querySelectorAll(".recommend-products-slider").forEach((element) => {
      element.classList.add("hidden");
      const goal = element.getAttribute('data-goal');
      if(goal > subtotal && subtotal > 0) element.classList.remove("hidden");
    
    });

    //
    if (window.Rebuy && typeof window.Rebuy.init === 'function') {
      window.Rebuy.init();
      // Also handle carousels directly after cart update
      setTimeout(() => handleRebuyCarousels(), 200);
    }

  } catch (error) {
    console.error('[renderCart] Error during render:', error);
  } finally {
    // Always release the lock, even if there was an error
    window.renderCartLock = false;
  }

  // On main cart page, keep main cart Vue in sync with the cart we just rendered (so GWP and items match)
  if (document.querySelector(".cart-grid--default") && typeof refreshMainCartVueState === "function" && cartDataForBonusOffer) {
    try { refreshMainCartVueState(cartDataForBonusOffer); } catch (e) {}
  }

  if (typeof handleQuantityInputs === "function") handleQuantityInputs();
  if (typeof handleRemoveItem === "function") handleRemoveItem();
  
  // Restore FREE GIFT display for GWP items if it was overwritten
  restoreGwpPriceDisplay();
  restoreBonusOfferBadge();
  // Apply gwp-none on GWP line items when milestone is not met (for CSS to hide)
  if (typeof applyGwpNoneClass === 'function' && cartDataForBonusOffer) applyGwpNoneClass(cartDataForBonusOffer);

  if (window.SubscribeSave && typeof window.SubscribeSave.updateCartSubtotal === 'function') {
    // Skip updateCartSubtotal if GWP operation is in progress to prevent fluctuation
    if (!window.gwpOperationInProgress) {
      window.SubscribeSave.updateCartSubtotal();
    }
  }

    if (typeof cleanupOrphanedBonusOfferItems === 'function' && cartDataForBonusOffer) {
    cleanupOrphanedBonusOfferItems(cartDataForBonusOffer)
      .then(function (removedOrphans) {
        if (removedOrphans) return;
        if (typeof syncBonusOfferUpsellAfterCartRender === 'function') {
          return syncBonusOfferUpsellAfterCartRender(cartDataForBonusOffer);
        }
      })
      .catch(function (err) {
        console.warn('[Bonus Offer Upsell] post-render sync failed:', err);
      });
  } else if (typeof syncBonusOfferUpsellAfterCartRender === 'function' && cartDataForBonusOffer) {
    syncBonusOfferUpsellAfterCartRender(cartDataForBonusOffer).catch(function (err) {
      console.warn('[Bonus Offer Upsell] sync failed:', err);
    });
  }
}

//Apply or remove 'gwp-none' class on GWP line items when milestone is not met.
async function applyGwpNoneClass(cartData) {
  if (!cartData || !cartData.items || !cartData.items.length) return;
  var gwpGoal = null;
  var gwpVariantId = null;
  var wrap = document.querySelector('.shipping-calculator-wrap[data-gwp-goal]') ||
    document.querySelector('.free-gift-calculator-wrap[data-gwp-goal]');
  if (wrap && wrap.getAttribute('data-gwp-goal')) {
    gwpGoal = parseInt(wrap.getAttribute('data-gwp-goal'), 10);
    if (wrap.getAttribute('data-gwp-product-id')) gwpVariantId = parseInt(wrap.getAttribute('data-gwp-product-id'), 10);
  }
  if (!wrap) {
    var freeGiftCalc = document.querySelector('.free-gift-calculator[data-goal]');
    if (freeGiftCalc) gwpGoal = parseInt(freeGiftCalc.getAttribute('data-goal'), 10);
  }
  if (!gwpVariantId) {
    var altWrap = document.querySelector('.shipping-calculator-wrap[data-gwp-product-id]') || document.querySelector('.free-gift-calculator-wrap[data-gwp-product-id]');
    if (altWrap) gwpVariantId = parseInt(altWrap.getAttribute('data-gwp-product-id'), 10);
  }
  if (!gwpGoal || gwpGoal <= 0) return;
  var subtotal = getSubtotalFromCartData(cartData);
  var milestoneMet = subtotal >= gwpGoal;
  var gwpLineItems = document.querySelectorAll('.mini-cart__item');
  gwpLineItems.forEach(function (row) {
    var priceEl = row.querySelector('.product-price[data-gwp-item="true"]');
    if (!priceEl) return;
    if (milestoneMet) {
      row.classList.remove('gwp-none');
    } else {
      row.classList.add('gwp-none');
    }
  });
  // When milestone is not met and GWP is in cart, remove GWP from cart so it does not go to checkout
  if (!milestoneMet && gwpVariantId && isGwpProductInCart(cartData, gwpVariantId)) {
    await removeGwpProductFromCart(cartData, gwpVariantId);
  }
}

/**
 * Restore FREE GIFT display for GWP items if it was overwritten
 */
function restoreGwpPriceDisplay() {
  // Find all GWP items by data attribute
  const gwpPriceElements = document.querySelectorAll('.product-price[data-gwp-item="true"]');
  
  gwpPriceElements.forEach(priceElement => {
    const savedHtml = priceElement.getAttribute('data-gwp-price-html');
    if (savedHtml) {
      const decodedHtml = decodeURIComponent(savedHtml);
      // Check if FREE GIFT is missing from current content
      if (!priceElement.innerHTML.includes('FREE GIFT') && !priceElement.querySelector('.free-price')) {
        // Restore the FREE GIFT display
        priceElement.innerHTML = decodedHtml;
      }
    }
  });
}

function restoreBonusOfferBadge() {
  const bonusPriceElements = document.querySelectorAll('.product-price[data-bonus-offer-html]');

  bonusPriceElements.forEach(priceElement => {
    const savedHtml = priceElement.getAttribute('data-bonus-offer-html');
    if (!savedHtml) return;

    try {
      const savedPriceHtml = priceElement.getAttribute('data-bonus-price-html');
      if (savedPriceHtml) {
        const decodedPriceHtml = decodeURIComponent(savedPriceHtml);
        // Re-apply bonus strikeout pricing if another script overwrote the price element.
        if (!priceElement.querySelector('.original-price')) {
          priceElement.innerHTML = decodedPriceHtml;
        }
      }

      if (priceElement.querySelector('.bonus-offer-badge')) return;
      const decodedHtml = decodeURIComponent(savedHtml);
      priceElement.insertAdjacentHTML('beforeend', ` ${decodedHtml}`);
    } catch (e) {
      // Ignore malformed encoded HTML
    }
  });
}

// Watch for changes to price elements and restore GWP display if needed
if (typeof MutationObserver !== 'undefined') {
  let gwpPriceObserver = null;
  
  function observeGwpPrices() {
    // Clean up existing observer
    if (gwpPriceObserver) {
      gwpPriceObserver.disconnect();
    }
    
    // Create new observer
    gwpPriceObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('product-price')) {
            const isGwp = target.getAttribute('data-gwp-item') === 'true';
            if (isGwp) {
              const savedHtml = target.getAttribute('data-gwp-price-html');
              if (savedHtml && !target.innerHTML.includes('FREE GIFT') && !target.querySelector('.free-price')) {
                // Restore FREE GIFT display
                const decodedHtml = decodeURIComponent(savedHtml);
                target.innerHTML = decodedHtml;
              }
            }
            if (target.getAttribute('data-bonus-offer-html') && !target.querySelector('.bonus-offer-badge')) {
              restoreBonusOfferBadge();
            }
          }
        }
      });
    });
    
    // Observe all existing price elements
    document.querySelectorAll('.product-price[data-gwp-item="true"], .product-price[data-bonus-offer-html]').forEach(element => {
      gwpPriceObserver.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
    
    // Also observe the cart container for new items
    const cartContainer = document.querySelector('.mini-cart__items');
    if (cartContainer) {
      gwpPriceObserver.observe(cartContainer, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Start observing after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGwpPrices);
  } else {
    observeGwpPrices();
  }
  
  // Re-observe after cart renders
  const originalRenderCart = window.renderCart;
  if (originalRenderCart) {
    window.renderCart = async function(...args) {
      const result = await originalRenderCart.apply(this, args);
      setTimeout(observeGwpPrices, 100);
      return result;
    };
  }
}

/**
 * Capture current subscription states from the UI and save to cache
 */
function captureSubscriptionStates() {
  const subscriptionStates = {};
  document.querySelectorAll('.subscribe-save-cart-ui').forEach(container => {
    const checkbox = container.querySelector('.subscribe-save-checkbox');
    const key = checkbox?.dataset.lineKey;
    if (!key) return;
    
    const isChecked = checkbox.checked || false;
    const interval = container.querySelector('.subscribe-dropdown')?.value || '45 Days';
    
    subscriptionStates[key] = {
      checked: isChecked,
      interval: interval
    };
    
    // Save to cache if user has interacted with this item
    if (checkbox.hasAttribute('data-user-interacted')) {
      setSubscriptionCache(key, isChecked);
    }
  });
  return subscriptionStates;
}

/**
 * Restore subscription states to the UI after cart re-render
 */
function restoreSubscriptionStates(subscriptionStates) {
  Object.entries(subscriptionStates).forEach(([key, state]) => {
    const container = document.querySelector(`.subscribe-save-checkbox[data-line-key="${key}"]`)?.closest('.subscribe-save-cart-ui');
    if (!container) return;

    const checkbox = container.querySelector('.subscribe-save-checkbox');
    const dropdownWrap = container.querySelector('.subscribe-save-dropdown-wrap');
    const dropdown = container.querySelector('.subscribe-dropdown');
    const textSpan = container.querySelector('.subscribe-save-text');
    const priceElement = container.closest('.mini-cart__item')?.querySelector('.product-price');

    checkbox.checked = state.checked;
    
    if (state.checked) {
      checkbox.setAttribute('checked', 'checked');
    } else {
      checkbox.removeAttribute('checked');
    }

    if (textSpan) {
      textSpan.innerHTML = state.checked ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount">15%</span>';
    }

    if (dropdownWrap) {
      dropdownWrap.style.display = state.checked ? 'block' : 'none';
    }

    if (dropdown && state.interval) {
      dropdown.value = state.interval;
    }

    const isBonusOfferLine = !!(priceElement && priceElement.getAttribute('data-bonus-offer-html'));
    if (priceElement && !isBonusOfferLine && window.SubscribeSave && window.SubscribeSave.updateItemPrice) {
      window.SubscribeSave.updateItemPrice(priceElement, state.checked);
    }

    checkbox.setAttribute('data-user-interacted', 'true');
    if (dropdown) {
      dropdown.setAttribute('data-user-interacted', 'true');
    }
  });

  // Update cart subtotal after restoring states
  if (window.SubscribeSave && window.SubscribeSave.updateCartSubtotal) {
    window.SubscribeSave.updateCartSubtotal();
  }
    restoreBonusOfferBadge();
}
function bonusOfferUpsellSectionFetchUrl() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var q = 'section_id=bonus-offer-upsell-ajax';
  return root.slice(-1) === '/' ? root + '?' + q : root + '/?' + q;
}

function parseHandleFromProductUrl(url) {
  if (!url) return '';
  var match = String(url).match(/\/products\/([^/?#]+)/i);
  return match ? match[1].toLowerCase() : '';
}

function normalizeCartProductHandle(value) {
  if (!value) return '';
  var s = String(value).toLowerCase().trim();
  if (s.indexOf('/products/') !== -1) return parseHandleFromProductUrl(s);
  return s;
}

function isCustomBundleCartItem(item) {
  return !!(
    item &&
    item.properties &&
    item.properties._bundle_type &&
    String(item.properties._bundle_type).indexOf('custom_set') === 0
  );
}

function parseBundleVariantsFromItem(item) {
  if (!item || !item.properties || !item.properties._bundle_variants) return [];
  try {
    var parsed = JSON.parse(item.properties._bundle_variants);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function getBundleConstituentHandlesFromItem(item, includeLineItemHandle) {
  var handles = {};
  if (!item) return [];

  if (includeLineItemHandle !== false) {
    var lineHandle = normalizeCartProductHandle(item.handle || item.product_handle || '');
    if (lineHandle) handles[lineHandle] = true;
  }

  if (!isCustomBundleCartItem(item)) {
    return Object.keys(handles);
  }

  var props = item.properties || {};
  if (typeof props._bundle_handles === 'string' && props._bundle_handles.trim()) {
    props._bundle_handles.split(',').forEach(function (h) {
      var clean = normalizeCartProductHandle(h);
      if (clean) handles[clean] = true;
    });
  }

  parseBundleVariantsFromItem(item).forEach(function (variant) {
    var clean = normalizeCartProductHandle(variant && variant.handle);
    if (clean) handles[clean] = true;
  });

  return Object.keys(handles);
}

function collectCartProductHandles(cartData) {
  var cartHandles = {};
  if (!cartData || !cartData.items) return cartHandles;

  cartData.items.forEach(function (item) {
    getBundleConstituentHandlesFromItem(item, true).forEach(function (handle) {
      cartHandles[handle] = true;
    });
  });

  return cartHandles;
}

function ensureBundleHandlesMigrated(cartData) {
  if (!cartData || !Array.isArray(cartData.items) || !cartData.items.length) {
    return Promise.resolve(cartData);
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var jobs = [];

  cartData.items.forEach(function (item) {
    if (!isCustomBundleCartItem(item)) return;

    var props = item.properties || {};
    if (props._bundle_handles && String(props._bundle_handles).trim()) return;

    var variants = parseBundleVariantsFromItem(item);
    if (!variants.length) return;

    jobs.push(
      Promise.all(
        variants.map(function (variant) {
          if (variant && variant.handle) {
            return Promise.resolve(normalizeCartProductHandle(variant.handle));
          }
          if (!variant || !variant.variantId) return Promise.resolve('');
          return fetch(root + 'variants/' + variant.variantId + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data) return '';
              return parseHandleFromProductUrl(data.url || '');
            })
            .catch(function () { return ''; });
        })
      ).then(function (resolvedHandles) {
        var enrichedVariants = variants.map(function (variant, index) {
          var next = Object.assign({}, variant);
          if (!next.handle) next.handle = resolvedHandles[index] || '';
          return next;
        });
        var bundleHandles = enrichedVariants
          .map(function (variant) { return normalizeCartProductHandle(variant.handle); })
          .filter(Boolean)
          .join(',');
        if (!bundleHandles) return false;

        var nextProps = Object.assign({}, props, {
          _bundle_handles: bundleHandles,
          _bundle_variants: JSON.stringify(enrichedVariants),
        });

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity || 1,
            properties: nextProps,
          }),
        }).then(function (r) { return r.ok; });
      })
    );
  });

  if (!jobs.length) return Promise.resolve(cartData);

  return Promise.all(jobs)
    .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }); })
    .then(function (r) { return r.json(); })
    .catch(function () { return cartData; });
}

function needsBonusOfferUpsellDomRefresh(cartData) {
  var list = document.querySelector('[data-bonus-offers-list]');
  if (!list) return false;
  if (!cartData || !cartData.items || !cartData.items.length) return false;
  var rows = list.querySelectorAll('.bonus-offer-upsell__item');
  var covered = {};
  rows.forEach(function (el) {
    var hin = (el.getAttribute('data-handle-in-cart') || '').toLowerCase();
    if (hin) covered[hin] = true;
  });
  var cartHandles = collectCartProductHandles(cartData);
  return Object.keys(cartHandles).some(function (h) {
    return h && !covered[h];
  });
}

function refreshBonusOfferUpsellFromSection(cartData) {
  var url = bonusOfferUpsellSectionFetchUrl();
  return fetch(url, {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Bonus offer section HTTP ' + r.status);
      return r.text();
    })
    .then(function (html) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var fresh = wrap.querySelector('.bonus-offer-upsell');
      var nodes = Array.from(document.querySelectorAll('.bonus-offer-upsell'));
      if (!nodes.length) return;
      if (!fresh) {
        nodes.forEach(function (node) {
          node.classList.add('is-empty');
          var ul = node.querySelector('[data-bonus-offers-list]');
          if (ul) ul.innerHTML = '';
        });
        if (typeof updateBonusOfferUpsell === 'function' && cartData) {
          return updateBonusOfferUpsell(cartData);
        }
        return;
      }
      nodes.forEach(function (node) {
        node.replaceWith(fresh.cloneNode(true));
      });
      if (typeof updateBonusOfferUpsell === 'function' && cartData) {
        return updateBonusOfferUpsell(cartData);
      }
    });
}

function syncBonusOfferUpsellAfterCartRender(cartData) {
  if (!document.querySelector('.bonus-offer-upsell')) return Promise.resolve();
  return ensureBundleHandlesMigrated(cartData).then(function (resolvedCartData) {
    var activeCartData = resolvedCartData || cartData;
    if (needsBonusOfferUpsellDomRefresh(activeCartData)) {
      return refreshBonusOfferUpsellFromSection(activeCartData).catch(function () {
        if (typeof updateBonusOfferUpsell === 'function' && activeCartData) {
          return updateBonusOfferUpsell(activeCartData);
        }
      });
    }
    if (typeof updateBonusOfferUpsell === 'function' && activeCartData) {
      return updateBonusOfferUpsell(activeCartData);
    }
    return Promise.resolve();
  });
}

function updateBonusOfferUpsell(cartData) {
  var containers = document.querySelectorAll('.bonus-offer-upsell');
  if (!containers.length) return Promise.resolve();

  var cartHandles = collectCartProductHandles(cartData);

  function shouldShow(itemEl) {
    var hIn = (itemEl.getAttribute('data-handle-in-cart') || '').toLowerCase();
    var hOut = (itemEl.getAttribute('data-handle-to-offer') || '').toLowerCase();
    var prio = parseInt(itemEl.getAttribute('data-priority') || '999', 10);
    if (!hIn || !hOut) return false;
    if (!cartHandles[hIn]) return false;
    if (cartHandles[hOut]) return false;
    return { hOut: hOut, priority: prio };
  }

  containers.forEach(function (block) {
    var list = block.querySelector('[data-bonus-offers-list]');
    if (!list) return;
    var items = list.querySelectorAll('.bonus-offer-upsell__item');
    var bestByOffer = {};
    var bestMetaByOffer = {};
    var anyVisible = false;
    items.forEach(function (item) {
      var s = shouldShow(item);
            if (!s) return;
      var p = isNaN(s.priority) ? 999 : s.priority;
      var existing = bestMetaByOffer[s.hOut];
      if (!existing || p < existing.priority) {
        bestByOffer[s.hOut] = item;
        bestMetaByOffer[s.hOut] = { priority: p };
      }
    });
    items.forEach(function (item) {
      var s = shouldShow(item);

      if (!s) {
        item.classList.add('is-hidden');
        return;
      }
      if (bestByOffer[s.hOut] !== item) {
        item.classList.add('is-hidden');
        return;
      }
      item.classList.remove('is-hidden');
      anyVisible = true;
    });
    if (anyVisible) block.classList.remove('is-empty'); else block.classList.add('is-empty');
  });

  return Promise.resolve();
}
function getBonusOfferParentHandlesByOfferFromDom() {
  var map = {};
  var rows = document.querySelectorAll('.bonus-offer-upsell__item[data-handle-in-cart][data-handle-to-offer]');
  rows.forEach(function (row) {
    var parentHandle = (row.getAttribute('data-handle-in-cart') || '').toLowerCase().trim();
    var offerHandle = (row.getAttribute('data-handle-to-offer') || '').toLowerCase().trim();
    if (!parentHandle || !offerHandle) return;
    if (!map[offerHandle]) map[offerHandle] = {};
    map[offerHandle][parentHandle] = true;
  });
  return map;
}

function collectParentHandlesForBonusItem(item, parentByOfferMap) {
  var handles = {};
  if (!item || !item.properties) item = item || {};
  var props = item.properties || {};
  var directParent = props['_bonus_parent_handle'] || props['_bonus-parent-handle'];
  var parentList = props['_bonus_parent_handles'];
  var hasExplicitParentBinding = false;

  if (typeof directParent === 'string' && directParent.trim()) {
    handles[directParent.toLowerCase().trim()] = true;
    hasExplicitParentBinding = true;
  }

  if (typeof parentList === 'string' && parentList.trim()) {
    parentList.split(',').forEach(function (h) {
      var clean = (h || '').toLowerCase().trim();
      if (clean) handles[clean] = true;
    });
    if (Object.keys(handles).length) hasExplicitParentBinding = true;
  }

  var offerHandle = (item.handle || '').toLowerCase().trim();
  if (!hasExplicitParentBinding && offerHandle && parentByOfferMap[offerHandle]) {
    Object.keys(parentByOfferMap[offerHandle]).forEach(function (h) {
      handles[h] = true;
    });
  }

  return Object.keys(handles);
}

function cleanupOrphanedBonusOfferItems(cartData) {
  if (!cartData || !Array.isArray(cartData.items) || !cartData.items.length) {
    return Promise.resolve(false);
  }

  if (window.bonusOfferCleanupInProgress) {
    return Promise.resolve(false);
  }

  var parentByOfferMap = getBonusOfferParentHandlesByOfferFromDom();
  var cartHandles = collectCartProductHandles(cartData);

  var cartHandleCounts = {};
  if (cartData && cartData.items) {
    cartData.items.forEach(function (item) {
      getBundleConstituentHandlesFromItem(item, true).forEach(function (h) {
        cartHandleCounts[h] = (cartHandleCounts[h] || 0) + 1;
      });
    });
  }

  var bonusCandidates = cartData.items
    .filter(function (item) {
      return !!(item && item.properties && (
        item.properties['_bonus-upsell-line-item'] === 'true' ||
        item.properties['_bonus-upsell-line-item'] === true ||
        item.properties['_bonus-upsell-line-item'] === '1'
      ));
    })
    .map(function (item) {
      return {
        item: item,
        handle: ((item && item.handle) || '').toLowerCase().trim(),
        parentHandles: collectParentHandlesForBonusItem(item, parentByOfferMap)
      };
    });

  var updates = {};
  var removedInPass = true;
  while (removedInPass) {
    removedInPass = false;

    bonusCandidates.forEach(function (candidate) {
      var item = candidate.item;
      if (!item || !item.key || updates[item.key] === 0) return;
      if (!candidate.parentHandles || !candidate.parentHandles.length) return;

      var hasParentInCart = candidate.parentHandles.some(function (h) {
        return (cartHandleCounts[h] || 0) > 0;
      });

      if (!hasParentInCart) {
        updates[item.key] = 0;
        removedInPass = true;

        if (candidate.handle && cartHandleCounts[candidate.handle]) {
          cartHandleCounts[candidate.handle] = Math.max(0, cartHandleCounts[candidate.handle] - (item.quantity || 1));
        }
      }
    });
  }

  var keys = Object.keys(updates);
  if (!keys.length) return Promise.resolve(false);

  window.bonusOfferCleanupInProgress = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Bonus offer cleanup failed');
      return fetch(root + 'cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (freshCartData) {
      if (typeof renderCart === 'function') {
        return renderCart(freshCartData);
      }
      return null;
    })
    .then(function () {
      document.dispatchEvent(new Event('cart:updated'));
      return true;
    })
    .catch(function (err) {
      console.warn('[Bonus Offer Upsell] orphan cleanup failed:', err);
      return false;
    })
    .finally(function () {
      window.bonusOfferCleanupInProgress = false;
    });
}

function initBonusOfferUpsell() {
  if (window.bonusOfferUpsellInitted) return;
  window.bonusOfferUpsellInitted = true;
  document.addEventListener('click', function (e) {
    var header = e.target.closest('.bonus-offer-upsell__header');
    if (header) {
      var block = header.closest('.bonus-offer-upsell');
      if (block) {
        e.preventDefault();
        block.classList.toggle('collapsed');
        var content = block.querySelector('.bonus-offer-upsell__content');
        if (content) content.setAttribute('aria-hidden', block.classList.contains('collapsed'));
        if (header) header.setAttribute('aria-expanded', !block.classList.contains('collapsed'));
      }
      return;
    }
    var btn = e.target.closest('.bonus-offer-upsell__add');
    if (!btn || btn.disabled) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    e.preventDefault();
    btn.disabled = true;
    var form = new FormData();
    form.append('id', vid);
    form.append('quantity', 1);
    form.append('properties[_widget_source]', 'bonus_offer');
    form.append('properties[_widget_section]', 'minicart_add_button');
    form.append('properties[_bonus-upsell-line-item]', 'true');
    var sourceRow = btn.closest('.bonus-offer-upsell__item');
    var parentHandle = sourceRow ? sourceRow.getAttribute('data-handle-in-cart') : '';
    if (parentHandle) form.append('properties[_bonus_parent_handle]', String(parentHandle).toLowerCase());
    var pct = btn.getAttribute('data-discount-pct');
    if (pct) form.append('properties[Bonus Offer]', pct + '% off');
    var originalCents = btn.getAttribute('data-original-cents');
    var discountedCents = btn.getAttribute('data-discounted-cents');
    if (originalCents) form.append('properties[_bonus_original_cents]', String(originalCents));
    if (discountedCents) form.append('properties[_bonus_discounted_cents]', String(discountedCents));
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: form })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.message || (res.status && res.status >= 400)) throw new Error(res.message || res.description || 'Add failed');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cartData) {
        if (typeof renderCart === 'function') renderCart(cartData);
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch(function (err) {
        console.warn('[Bonus Offer Upsell] Add to cart failed:', err);
        btn.disabled = false;
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBonusOfferUpsell);
} else {
  initBonusOfferUpsell();
}

// Global function to update shipping calculator with current displayed prices
var _lastUpdateShippingCalculatorTime = 0;
var UPDATE_SHIPPING_CALCULATOR_THROTTLE_MS = 400;

function updateShippingCalculator() {
  // Skip if GWP operation is in progress to prevent subtotal fluctuation
  if (window.gwpOperationInProgress) {
    return;
  }
  
  var now = Date.now();
  if (now - _lastUpdateShippingCalculatorTime < UPDATE_SHIPPING_CALCULATOR_THROTTLE_MS) {
    return;
  }
  _lastUpdateShippingCalculatorTime = now;

  // Calculate subtotal based on displayed prices (includes manual subscription discounts)
  function calculateDisplayedSubtotal() {
    let displayedSubtotal = 0;
    const cartItems = document.querySelectorAll('.mini-cart__item');
    
    cartItems.forEach(item => {
      const priceElement = item.querySelector('.product-price');
      
      // Check if item is GWP (Gift With Purchase) - exclude from shipping calculation
      // Check for data-gwp-item attribute and free-price element first (most reliable)
      const isGwpItem = priceElement && (
        priceElement.getAttribute('data-gwp-item') === 'true' ||
        priceElement.querySelector('.free-price') !== null
      ) || item.querySelector('.gwp-badge') || 
         item.querySelector('[class*="gwp"]') ||
         item.textContent.includes('GWP') ||
         item.textContent.includes('Discount applied at next step');
      
      if (!isGwpItem) {
        if (priceElement) {
          const priceSpan = priceElement.querySelector('.discounted-price');
          if (priceSpan) {
            const priceText = priceSpan.textContent.trim();
            const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
            if (priceMatch) {
              const amount = parseFloat(priceMatch[1].replace(',', ''));
              displayedSubtotal += amount;
            }
          }
        }
      }
    });
    
    return displayedSubtotal * 100; // Convert to cents for consistency with original subtotal
  }

  const displayedSubtotal = calculateDisplayedSubtotal();
  
  // Update unified progress bar (includes both shipping and gift milestones)
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      updateUnifiedProgressBar(displayedSubtotal, cartData);
      if (typeof applyGwpNoneClass === 'function') applyGwpNoneClass(cartData);
    })
    .catch((err) => console.log('Error fetching cart for unified progress:', err));
}

/**
 * Check if there's any GWP product (active or unlisted) available
 * Checks products in cart and also searches for GWP products
 */
async function checkForGwpProductAvailable(cartData) {
  // First check the shipping-calculator-wrap for GWP product ID (moved from free-gift-calculator-wrap)
  const shippingCalculatorWrap = document.querySelector('.shipping-calculator-wrap');
  if (shippingCalculatorWrap && shippingCalculatorWrap.hasAttribute('data-gwp-product-id')) {
    const gwpVariantId = shippingCalculatorWrap.getAttribute('data-gwp-product-id');
    if (gwpVariantId) {
      return { hasGwp: true, gwpProduct: { variantId: parseInt(gwpVariantId) } };
    }
  }
  
  // Also check free-gift-calculator-wrap as fallback
  const freeGiftWrap = document.querySelector('.free-gift-calculator-wrap');
  if (freeGiftWrap && freeGiftWrap.hasAttribute('data-gwp-product-id')) {
    const gwpVariantId = freeGiftWrap.getAttribute('data-gwp-product-id');
    if (gwpVariantId) {
      return { hasGwp: true, gwpProduct: { variantId: parseInt(gwpVariantId) } };
    }
  }

  // Also check cart items for any GWP products (active or unlisted with GWP tag)
  if (cartData && cartData.items && cartData.items.length > 0) {
    for (const item of cartData.items) {
      if (!item.handle) {
        continue;
      }

      try {
        const productResponse = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`);
        if (productResponse.ok) {
          const productData = await productResponse.json();
          
          // Include both active and unlisted products (both have published_at set)
          // Only skip draft products (published_at is null)
          if (!productData.published_at) {
            continue; // Skip draft products only
          }

          // Check product tags for GWP tag (case-insensitive)
          const productTags = productData.tags || [];
          const hasGwpTag = productTags.some(tag => 
            tag.toLowerCase().includes('gwp')
          );
          
          if (hasGwpTag) {
            // Found a GWP product, use the first available variant
            const gwpProduct = {
              variantId: productData.variants && productData.variants.length > 0 
                ? productData.variants[0].id 
                : null,
              handle: item.handle,
              productId: productData.id
            };
            return { hasGwp: true, gwpProduct };
          }
        }
      } catch (error) {
        // Silently continue checking other items if fetch fails
      }
    }
  }

  return { hasGwp: false, gwpProduct: null };
}

/**
 * Check if GWP product is already in cart
 */
function isGwpProductInCart(cartData, gwpVariantId) {
  if (!cartData || !cartData.items || !gwpVariantId) {
    return false;
  }
  
  return cartData.items.some(item => {
    // Check by variant ID
    if (item.variant_id && item.variant_id === gwpVariantId) {
      return true;
    }
    // Check by properties
    if (item.properties) {
      return item.properties["_gwp_nc"] === "1" || 
             item.properties["_gift_for_purchase"] === "true" ||
             (item.properties["Note"] && item.properties["Note"].includes("GWP"));
    }
    return false;
  });
}

/**
 * Get all GWP items in cart (for duplicate detection)
 */
function getAllGwpItemsInCart(cartData, gwpVariantId) {
  if (!cartData || !cartData.items || !gwpVariantId) {
    return [];
  }
  
  return cartData.items.filter(item => {
    // Check by variant ID
    if (item.variant_id && item.variant_id === gwpVariantId) {
      return true;
    }
    // Check by properties
    if (item.properties) {
      return item.properties["_gwp_nc"] === "1" || 
             item.properties["_gift_for_purchase"] === "true" ||
             (item.properties["Note"] && item.properties["Note"].includes("GWP"));
    }
    return false;
  });
}

function isGwpCartItem(item) {
  return item.properties && (
    (item.properties["Note"] && item.properties["Note"].includes("GWP")) ||
    (item.properties["note"] && item.properties["note"].includes("GWP")) ||
    (item.properties.Note && item.properties.Note.includes("GWP")) ||
    (item.properties["_Note"] && item.properties["_Note"].includes("GWP")) ||
    item.properties["_gwp_nc"] === "1" ||
    item.properties["_gift_for_purchase"] === "true"
  );
}

function getSubtotalFromCartData(cartData) {
  if (!cartData || !cartData.items || !cartData.items.length) return 0;
  var subtotal = 0;
  for (var i = 0; i < cartData.items.length; i++) {
    var item = cartData.items[i];
    if (isGwpCartItem(item)) continue;
    // var isBundleItem = item.properties && item.properties._bundle_type === "custom_set";
     var isBundleItem = item.properties && item.properties._bundle_type && item.properties._bundle_type.startsWith("custom_set");
    if (isBundleItem) {
      var bundleAmount = 0;
      try {
        var bundleVariants = item.properties && item.properties._bundle_variants
          ? JSON.parse(item.properties._bundle_variants)
          : null;
        if (Array.isArray(bundleVariants) && bundleVariants.length) {
          var unitBundleTotal = bundleVariants.reduce(function (sum, variant) {
            var variantPrice = variant && typeof variant.price === "number" ? variant.price : 0;
            return sum + variantPrice;
          }, 0);
          var bundleQty = item.quantity || 1;
          bundleAmount = unitBundleTotal * bundleQty;
        }
      } catch (e) {}
      if (!bundleAmount) {
        bundleAmount = item.final_line_price != null ? item.final_line_price : (item.price || 0) * (item.quantity || 0);
      }
      subtotal += bundleAmount;
      continue;
    }
    var amount = item.final_line_price != null ? item.final_line_price : (item.price || 0) * (item.quantity || 0);
    subtotal += amount;
  }
  return subtotal;
}

/** True if payload is a full cart object (has .items array). cart/change.js returns a line item, not full cart. */
function isFullCartPayload(payload) {
  return payload && typeof payload === "object" && Array.isArray(payload.items);
}

/** Format cents to money string (GWP excluded subtotal). Uses BARREL.moneyFormat if available. */
function formatMoneyCents(cents) {
  var amount = (cents / 100).toFixed(2);
  var format = window.BARREL && window.BARREL.moneyFormat;
  if (format && typeof format === "string") {
    return format.replace(/\{\{\s*amount\s*\}\}/gi, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, Math.round(cents / 100));
  }
  return "$" + amount;
}

/** Update main cart sidebar subtotal to show non-GWP total (GWP items count as $0). */
function updateMainCartSidebarSubtotal(cartData) {
  if (!cartData || !document.querySelector(".cart-grid--default")) return;
  var subtotalCents = getSubtotalFromCartData(cartData);
  var formatted = formatMoneyCents(subtotalCents);
  var el = document.querySelector(".cart-grid--default .cart__sidebar .cart__subtotal h3");
  if (el) el.textContent = formatted;
}

/** Delay (ms) so sidebar subtotal runs after Vue has re-rendered (e.g. after quantity change). */
var MAIN_CART_SIDEBAR_SUBTOTAL_DELAY = 120;

var _mainCartStorePatched = false;
/** Prevents Vue from overwriting cart with a single line item (e.g. from cart/change.js). When on main cart, only allow full cart in refreshCart. */
function patchMainCartStoreOnce(store) {
  if (!store || _mainCartStorePatched) return;
  var originalCommit = store.commit;
  if (!originalCommit) return;
  store.commit = function (type, payload) {
    if (type === "refreshCart" && payload && !isFullCartPayload(payload)) {
      fetch(window.Shopify.routes.root + "cart.js")
        .then(function (r) { return r.json(); })
        .then(function (fullCart) {
          if (window.BARREL && window.BARREL.cart !== undefined) window.BARREL.cart = fullCart;
          originalCommit.call(store, "refreshCart", fullCart);
          setTimeout(function () { updateMainCartSidebarSubtotal(fullCart); }, MAIN_CART_SIDEBAR_SUBTOTAL_DELAY);
          setTimeout(function () { updateMainCartSidebarSubtotal(fullCart); }, MAIN_CART_SIDEBAR_SUBTOTAL_DELAY + 150);
        })
        .catch(function () { originalCommit.call(store, type, payload); });
      return;
    }
    var result = originalCommit.apply(store, arguments);
    if (type === "refreshCart" && payload && isFullCartPayload(payload) && document.querySelector(".cart-grid--default")) {
      setTimeout(function () { updateMainCartSidebarSubtotal(payload); }, MAIN_CART_SIDEBAR_SUBTOTAL_DELAY);
      setTimeout(function () { updateMainCartSidebarSubtotal(payload); }, MAIN_CART_SIDEBAR_SUBTOTAL_DELAY + 150);
    }
    return result;
  };
  _mainCartStorePatched = true;
}

function refreshMainCartVueState(freshCartData) {
  if (!freshCartData || !document.querySelector(".cart-grid--default")) return;
  try {
    if (window.BARREL && window.BARREL.cart !== undefined) {
      window.BARREL.cart = freshCartData;
    }
    var cartGridRoot = document.querySelector(".cart-grid--default");
    var parent = cartGridRoot && cartGridRoot.closest ? cartGridRoot.closest("[data-module='cart-grid']") : null;
    var vueInstance = (cartGridRoot && cartGridRoot.__vue__) || (parent && parent.__vue__);
    if (vueInstance && vueInstance.$store) {
      patchMainCartStoreOnce(vueInstance.$store);
      vueInstance.$store.commit("refreshCart", freshCartData);
    }
    // Sidebar subtotal: show amount with GWP items as $0 (overwrite Vue's total_price after it renders)
    setTimeout(function () { updateMainCartSidebarSubtotal(freshCartData); }, MAIN_CART_SIDEBAR_SUBTOTAL_DELAY);
  } catch (e) {}
}

var _mainCartVueReapplyTimeout = null;
function scheduleMainCartVueReapply() {
  if (!document.querySelector(".cart-grid--default")) return;
  clearTimeout(_mainCartVueReapplyTimeout);
  _mainCartVueReapplyTimeout = setTimeout(function() {
    _mainCartVueReapplyTimeout = null;
    fetch(window.Shopify.routes.root + "cart.js")
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        refreshMainCartVueState(cart);
      })
      .catch(function() {});
  }, 700);
}

var _lastGwpChangeTime = 0;
var GWP_COOLDOWN_MS = 2500;

async function syncMainCartGwpFromMilestone() {
  if (!document.querySelector(".cart-grid--default")) return;
  var wrap = document.querySelector(".shipping-calculator-wrap[data-gwp-product-id][data-gwp-goal]");
  if (!wrap || gwpOperationInProgress) return;
  var now = Date.now();
  if (now - _lastGwpChangeTime < GWP_COOLDOWN_MS) return;
  var gwpProductId = wrap.getAttribute("data-gwp-product-id");
  var gwpGoal = parseInt(wrap.getAttribute("data-gwp-goal"), 10);
  var shippingGoalAttr = wrap.getAttribute("data-shipping-goal");
  var shippingGoal = shippingGoalAttr ? parseInt(shippingGoalAttr, 10) : 0;
  if (!gwpProductId || !gwpGoal || gwpGoal <= shippingGoal) return;
  try {
    var response = await fetch(window.Shopify.routes.root + "cart.js");
    var cartData = await response.json();
    var subtotal = getSubtotalFromCartData(cartData);
    var gwpProduct = { variantId: parseInt(gwpProductId, 10) };
    var gwpInCart = isGwpProductInCart(cartData, gwpProduct.variantId);
    if (subtotal < gwpGoal) {
      clearGwpAutoAddDismissed(gwpProduct.variantId);
    }
    if (subtotal >= gwpGoal) {
      if (!gwpInCart && !isGwpAutoAddDismissed(gwpProduct.variantId)) {
        var added = await addGwpProductToCart(gwpProduct, cartData);
        if (added) {
          _lastGwpChangeTime = Date.now();
          var freshRes = await fetch(window.Shopify.routes.root + "cart.js");
          var freshCart = await freshRes.json();
          refreshMainCartVueState(freshCart);
          scheduleMainCartVueReapply();
          return;
        }
      }
    }
  } catch (e) {}
}

/**
 * Add GWP product to cart
 * Ensures quantity stays at 1 even if item already exists
 * Prevents duplicates by removing all existing GWP items first if duplicates found
 */
async function addGwpProductToCart(gwpProduct, cartData) {
  if (!gwpProduct || !gwpProduct.variantId) {
    return false;
  }

  // Prevent concurrent operations
  if (gwpOperationInProgress) {
    return false;
  }

  gwpOperationInProgress = true;
  window.gwpOperationInProgress = true;

  try {
    // Get ALL GWP items (including duplicates)
    const allGwpItems = getAllGwpItemsInCart(cartData, gwpProduct.variantId);

    // If there are duplicates (more than 1), remove all first
    if (allGwpItems.length > 1) {
      const updates = {};
      allGwpItems.forEach(item => {
        updates[item.key] = 0; // Remove all duplicates
      });
      
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      
      // Get fresh cart data after cleanup
      const freshCartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      cartData = await freshCartResponse.json();
    }

    // Now check if GWP item exists (should be 0 or 1 at this point)
    const existingGwpItem = cartData && cartData.items ? 
      cartData.items.find(item => {
        if (item.variant_id === gwpProduct.variantId) return true;
        if (item.properties) {
          return item.properties["_gwp_nc"] === "1" || 
                 item.properties["_gift_for_purchase"] === "true" ||
                 (item.properties["Note"] && item.properties["Note"].includes("GWP"));
        }
        return false;
      }) : null;

    if (existingGwpItem) {
      // Item exists, ensure quantity is exactly 1
      if (existingGwpItem.quantity !== 1) {
        const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: existingGwpItem.key,
            quantity: 1
          }),
        });

        if (response.ok) {
          // Get fresh cart and render
          const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
          const freshCartData = await cartResponse.json();
          await renderCart(freshCartData);
          // Delay event dispatch to prevent cascade
          setTimeout(() => {
            document.dispatchEvent(new Event('cart:updated'));
          }, 100);
          return true;
        }
      }
      // Quantity is already 1, no need to do anything
      return true;
    }

    // Item doesn't exist, add it with quantity 1
    const formData = new FormData();
    formData.append("id", gwpProduct.variantId);
    formData.append("quantity", 1);
    formData.append("properties[_gwp_nc]", "1");
    formData.append("properties[_gift_for_purchase]", "true");
    formData.append("properties[Note]", "Discount applied at next step");

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      // Get fresh cart and render
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const freshCartData = await cartResponse.json();
      await renderCart(freshCartData);
      // Delay event dispatch to prevent cascade
      setTimeout(() => {
        document.dispatchEvent(new Event('cart:updated'));
      }, 100);
      return true;
    }
  } catch (error) {
  } finally {
    // Reset flag after a delay to allow operations to complete
    setTimeout(() => {
      gwpOperationInProgress = false;
      window.gwpOperationInProgress = false;
    }, 500);
  }
  return false;
}

/**
 * Remove GWP product from cart
 */
async function removeGwpProductFromCart(cartData, gwpVariantId) {
  if (!cartData || !cartData.items || !gwpVariantId) {
    return false;
  }

  // Prevent concurrent operations
  if (gwpOperationInProgress) {
    return false;
  }

  gwpOperationInProgress = true;
  window.gwpOperationInProgress = true;

  try {
    const gwpItems = getAllGwpItemsInCart(cartData, gwpVariantId);

    if (gwpItems.length === 0) {
      return false;
    }

    const updates = {};
    gwpItems.forEach(item => {
      updates[item.key] = 0;
    });

    const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });

    if (response.ok) {
      // Get fresh cart and render
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const freshCartData = await cartResponse.json();
      await renderCart(freshCartData);
      // Delay event dispatch to prevent cascade
      setTimeout(() => {
        document.dispatchEvent(new Event('cart:updated'));
      }, 100);
      return true;
    }
  } catch (error) {
  } finally {
    // Reset flag after a delay to allow operations to complete
    setTimeout(() => {
      gwpOperationInProgress = false;
      window.gwpOperationInProgress = false;
    }, 500);
  }
  return false;
}

/**
 * Update free gift progress bar
 */
async function updateFreeGiftProgress(displayedSubtotal, cartData) {
  let freeGiftWrap = null;
  
  freeGiftWrap = document.querySelector('.free-gift-calculator-wrap');
  
  if (!freeGiftWrap) {
    const cartGridItems = document.querySelector('.cart-grid_items, .cart-grid-items-wrap');
    if (cartGridItems) {
      freeGiftWrap = cartGridItems.querySelector('.free-gift-calculator-wrap');
    }
    
    if (!freeGiftWrap) {
      const cartGrid = document.querySelector('.cart-grid, .js-cart-grid, [data-module="cart-grid"]');
      if (cartGrid) {
        freeGiftWrap = cartGrid.querySelector('.free-gift-calculator-wrap');
      }
    }
    
    if (!freeGiftWrap) {
      const miniCart = document.querySelector('.mini-cart');
      if (miniCart) {
        freeGiftWrap = miniCart.querySelector('.free-gift-calculator-wrap');
      }
    }
  }
  
  if (!freeGiftWrap && cartData && (!cartData.items || cartData.items.length === 0)) {
    return;
  }
  
  if (!freeGiftWrap) {
    setTimeout(() => {
      freeGiftWrap = document.querySelector('.free-gift-calculator-wrap');
      if (freeGiftWrap) {
        updateFreeGiftProgress(displayedSubtotal, cartData);
      }
    }, 300);
    return;
  }

  const { hasGwp, gwpProduct } = await checkForGwpProductAvailable(cartData);
  
  if (!hasGwp || !gwpProduct) {
    freeGiftWrap.style.display = 'none';
    return;
  }

  freeGiftWrap.style.display = 'block';

  // Check free shipping threshold is reached
  const shippingCalculator = document.querySelector('.shipping-calculator[data-goal]');
  const shippingGoal = shippingCalculator ? shippingCalculator.getAttribute('data-goal') : null;
  const shippingGoalReached = document.querySelector('[data-id="goalReached"]:not(.hidden)');
  const isFreeShippingReached = shippingGoalReached || (shippingGoal && displayedSubtotal >= parseInt(shippingGoal));
  
  // Get GWP threshold
  const freeGiftCalculator = document.querySelector('.free-gift-calculator');
  const gwpGoal = freeGiftCalculator ? freeGiftCalculator.getAttribute('data-goal') : null;
  
  if (!gwpGoal) {
    freeGiftWrap.style.display = 'none';
    return;
  }

  const gwpGoalAmount = parseInt(gwpGoal);
  const shippingGoalAmount = shippingGoal ? parseInt(shippingGoal) : 0;

  let progressAmount = 0;
  let remaining = 0;
  
  if (isFreeShippingReached) {
    const amountAfterFreeShipping = displayedSubtotal - shippingGoalAmount;
    const gwpProgressNeeded = gwpGoalAmount - shippingGoalAmount;
    
    progressAmount = Math.max(0, amountAfterFreeShipping);
    remaining = Math.max(0, gwpProgressNeeded - amountAfterFreeShipping);
    
    if (remaining <= 0 && gwpProduct.variantId) {
      const gwpInCart = isGwpProductInCart(cartData, gwpProduct.variantId);
      if (!gwpInCart && !isGwpAutoAddDismissed(gwpProduct.variantId)) {
        await addGwpProductToCart(gwpProduct, cartData);
      } else {
        // Ensure quantity is 1 only for GWP already in cart.
        if (gwpInCart) {
          await addGwpProductToCart(gwpProduct, cartData);
        }
      }
    
    }
    // No auto-remove: GWP stays in cart once added (only add when milestone reached)
  } else {
    const gwpProgressNeeded = gwpGoalAmount - shippingGoalAmount;
    remaining = gwpProgressNeeded;
    progressAmount = 0;
    if (gwpProduct.variantId) {
      clearGwpAutoAddDismissed(gwpProduct.variantId);
    }
  }

  const remainingFormatted = `$${(remaining / 100).toFixed(2)}`;
  
  const gwpProgressNeeded = gwpGoalAmount - shippingGoalAmount;
  const progressPercent = gwpProgressNeeded > 0 
    ? Math.min(100, Math.max(0, (progressAmount * 100) / gwpProgressNeeded))
    : 0;

  const progressBar = freeGiftCalculator.querySelector('.free-shipping-progress__bar');
  if (progressBar) {
    progressBar.style.width = `${progressPercent}%`;
  }

  const giftProgress = freeGiftCalculator.querySelector('[data-id="giftProgress"]');
  const giftReached = freeGiftCalculator.querySelector('[data-id="giftReached"]');
  
  if (giftProgress) giftProgress.classList.add('hidden');
  if (giftReached) giftReached.classList.add('hidden');

  if (remaining <= 0 && isFreeShippingReached) {
    if (giftReached) {
      giftReached.classList.remove('hidden');
    }
  } else {
    if (giftProgress) {
      const remainingAmountEl = giftProgress.querySelector('.gift-remaining-amount');
      if (remainingAmountEl) {
        remainingAmountEl.textContent = remainingFormatted;
      }
      giftProgress.classList.remove('hidden');
    }
  }
}

/**
 * Update unified progress bar with both shipping and gift milestones
 */
async function updateUnifiedProgressBar(displayedSubtotal, cartData) {
  const shippingCalculatorWrap = document.querySelector('.shipping-calculator-wrap');
  if (!shippingCalculatorWrap) {
    return;
  }

  const shippingGoal = shippingCalculatorWrap.getAttribute('data-shipping-goal');
  const gwpGoal = shippingCalculatorWrap.getAttribute('data-gwp-goal');
  
  if (!shippingGoal) {
    // Fallback to old shipping calculator logic
    document.querySelectorAll(".shipping-calculator").forEach((element) => {
      const goal = element.getAttribute('data-goal');
      let shipping_diff = `$${((goal - displayedSubtotal) / 100).toFixed(2)}`;
      let widthValue = goal === 0
      ? "100%"
      : `${(displayedSubtotal * 100) / goal}%`;

      const priceElement = document.querySelector('.free-shipping-progress__text [v-text="price"]');
      if (priceElement) {
        priceElement.textContent = shipping_diff;
      }
      
      document.querySelectorAll('.shipping-text').forEach(el => el.classList.add('hidden'));
      if(goal == 0) {
        document.querySelector('[data-id="beforeGoal"]')?.classList.remove('hidden');
      }
      else if(goal <= displayedSubtotal) {
        document.querySelector('[data-id="goalReached"]')?.classList.remove('hidden');
      }
      else {
        document.querySelector('[data-id="goalStarted"]')?.classList.remove('hidden');
      }
      const parent = document.querySelector('.shipping-text:not(.hidden)');
      if (parent) {
        parent.querySelector('.free-shipping-progress__bar').style.width = widthValue;
      }
    });
    return;
  }

  const shippingGoalAmount = parseInt(shippingGoal);
  const gwpGoalAmount = gwpGoal ? parseInt(gwpGoal) : null;
  
  // Check if GWP product is available
  const { hasGwp } = await checkForGwpProductAvailable(cartData);
  const showGiftMilestone = hasGwp && gwpGoalAmount && gwpGoalAmount > shippingGoalAmount;
  
  // Calculate progress
  const maxGoal = showGiftMilestone ? gwpGoalAmount : shippingGoalAmount;
  const progressPercent = maxGoal > 0 
    ? Math.min(100, Math.max(0, (displayedSubtotal * 100) / maxGoal))
    : 0;
  
  // Find the currently visible progress container (not hidden)
  const visibleShippingText = document.querySelector('.shipping-text:not(.hidden)');
  const progressBarWrapper = visibleShippingText ? visibleShippingText.querySelector('.progress-bar-wrapper') : null;
  
  // Update all progress bar fills (there might be multiple in different states)
  const progressFills = document.querySelectorAll('#unified-progress-fill');
  progressFills.forEach(fill => {
    fill.style.width = `${progressPercent}%`;
  });
  
  // Update all milestones (both visible and hidden to keep them in sync)
  const shippingMilestones = document.querySelectorAll('#milestone-shipping');
  const giftMilestones = document.querySelectorAll('#milestone-gift');
  
  // Calculate milestone positions
  let shippingPosition = 100; // Default to 100% if no gift milestone
  if (showGiftMilestone && gwpGoalAmount > 0) {
    shippingPosition = (shippingGoalAmount * 100) / gwpGoalAmount;
    // Clamp to valid range
    shippingPosition = Math.max(0, Math.min(100, shippingPosition));
  }
  
  // Update all shipping milestones
  shippingMilestones.forEach(milestone => {
    milestone.style.left = `${shippingPosition}%`;
    
    if (displayedSubtotal >= shippingGoalAmount) {
      milestone.classList.add('milestone-active');
    } else {
      milestone.classList.remove('milestone-active');
    }
  });
  
  // Update all gift milestones
  giftMilestones.forEach(milestone => {
    if (showGiftMilestone) {
      milestone.style.display = 'flex';
      milestone.style.left = '100%';
      
      if (displayedSubtotal >= gwpGoalAmount) {
        milestone.classList.add('milestone-active');
      } else {
        milestone.classList.remove('milestone-active');
      }
    } else {
      milestone.style.display = 'none';
    }
  });
  
  // Update message (update all message elements to keep them in sync)
 const progressMessages = document.querySelectorAll('#unified-progress-message');
  let messageText = '';
  const gwpProductIdAttr = shippingCalculatorWrap.getAttribute('data-gwp-product-id');
  const gwpVariantId = gwpProductIdAttr ? parseInt(gwpProductIdAttr, 10) : null;
  const gwpInCart = cartData && gwpVariantId ? isGwpProductInCart(cartData, gwpVariantId) : false;

  if (displayedSubtotal >= shippingGoalAmount && (!showGiftMilestone || displayedSubtotal >= gwpGoalAmount)) {
    // Free shipping reached; show gifts message only when GWP is applied (in cart)
    messageText = (showGiftMilestone && displayedSubtotal >= gwpGoalAmount && gwpInCart)
      ? 'Congratulations! Free US shipping + gifts unlocked'
      : 'Free shipping on all orders within the United States.';
  } else if (displayedSubtotal >= shippingGoalAmount && showGiftMilestone) {
    const remaining = gwpGoalAmount - displayedSubtotal;
    messageText = `Add <em>$${(remaining / 100).toFixed(2)}</em> more to enjoy bonus gifts!`;
  } else {
    const remaining = shippingGoalAmount - displayedSubtotal;
    messageText = `You're <em>$${(remaining / 100).toFixed(2)}</em> away from free shipping within the United States!`;
  }
  
  progressMessages.forEach(message => {
    if (messageText.includes('<em>')) {
      message.innerHTML = messageText;
    } else {
      message.textContent = messageText;
    }
  });
  
  // Show/hide appropriate states
  document.querySelectorAll('.shipping-text').forEach(el => el.classList.add('hidden'));
  
  let activeState = null;
  if (shippingGoalAmount == 0) {
    activeState = document.querySelector('[data-id="beforeGoal"]');
    activeState?.classList.remove('hidden');
  } else if (displayedSubtotal >= shippingGoalAmount) {
    activeState = document.querySelector('[data-id="goalReached"]');
    activeState?.classList.remove('hidden');
  } else {
    activeState = document.querySelector('[data-id="goalStarted"]');
    activeState?.classList.remove('hidden');
  }
  
  // After showing the active state, ensure milestones in that state are also updated
  // This handles the case where Vue transitions might have delayed rendering
  if (activeState) {
    const activeMilestones = activeState.querySelectorAll('.milestone');
    activeMilestones.forEach(milestone => {
      if (milestone.id === 'milestone-shipping') {
        milestone.style.left = `${shippingPosition}%`;
        if (displayedSubtotal >= shippingGoalAmount) {
          milestone.classList.add('milestone-active');
        } else {
          milestone.classList.remove('milestone-active');
        }
      } else if (milestone.id === 'milestone-gift') {
        if (showGiftMilestone) {
          milestone.style.display = 'flex';
          milestone.style.left = '100%';
          if (displayedSubtotal >= gwpGoalAmount) {
            milestone.classList.add('milestone-active');
          } else {
            milestone.classList.remove('milestone-active');
          }
        } else {
          milestone.style.display = 'none';
        }
      }
    });
  }

  if (typeof applyGwpNoneClass === 'function' && cartData) applyGwpNoneClass(cartData);
  
  // Auto-add GWP product when threshold is reached (no auto-remove; GWP stays once added)
  // Skip if GWP operation is already in progress to prevent duplicates and flickering
  if (gwpOperationInProgress) {
    return;
  }

  // On main cart page, GWP is handled only by syncMainCartGwpFromMilestone. Do not add here,
  // or displayedSubtotal (from drawer .mini-cart__item) can be wrong and we remove the GWP, making it disappear from cart__body.
  if (document.querySelector(".cart-grid--default")) {
    return;
  }

  if (showGiftMilestone) {
    const gwpProductId = shippingCalculatorWrap.getAttribute('data-gwp-product-id');
    if (gwpProductId) {
      const gwpProduct = { variantId: parseInt(gwpProductId) };
      const gwpInCart = isGwpProductInCart(cartData, gwpProduct.variantId);
      if (displayedSubtotal < gwpGoalAmount) {
        clearGwpAutoAddDismissed(gwpProduct.variantId);
      }
      
      const isFreeShippingReached = displayedSubtotal >= shippingGoalAmount;
      
      if (isFreeShippingReached && displayedSubtotal >= gwpGoalAmount) {
        if (!gwpInCart && !isGwpAutoAddDismissed(gwpProduct.variantId)) {
          await addGwpProductToCart(gwpProduct, cartData);
        } else {
          // Check if quantity is correct, if not fix it
          const gwpItem = cartData.items.find(item => {
            if (item.variant_id === gwpProduct.variantId) return true;
            if (item.properties) {
              return item.properties["_gwp_nc"] === "1" ||
                     item.properties["_gift_for_purchase"] === "true" ||
                     (item.properties["Note"] && item.properties["Note"].includes("GWP"));
            }
            return false;
          });

          if (gwpItem && gwpItem.quantity !== 1) {
            await addGwpProductToCart(gwpProduct, cartData);
          }
        }
      }
    }
  }
}

// Export to window so it can be used from other files
window.updateShippingCalculator = updateShippingCalculator;
window.getSubscriptionCache = getSubscriptionCache;
window.setSubscriptionCache = setSubscriptionCache;
window.loadSubscriptionCache = loadSubscriptionCache;
window.updateFreeGiftProgress = updateFreeGiftProgress;
window.updateUnifiedProgressBar = updateUnifiedProgressBar;


/**
 * Attaches event listeners to the quantity input buttons, and
 * updates the value of the quantity input field.
 */

function handleQuantityInputs() {
  // Get a refernce to any quantity inputs
  const qtyInputEls = document.querySelectorAll(".mini-cart .quantity-input");

  // If there are any then loop through them and attach event listeners
  if (qtyInputEls.length > 0) {
    qtyInputEls.forEach((input) => {
      let plusBtn = input.querySelector(".plus");
      let minusBtn = input.querySelector(".minus");
      let qtyInput = input.querySelector(".item__quantity");
      let lineKey = input.querySelector(".item__line-key").value;

      // Store previous valid quantity in a data attribute
      qtyInput.setAttribute("data-prev-value", qtyInput.value);

      // Increase the quantity input value
      plusBtn.addEventListener("click", () => {
        let newQty = parseInt(qtyInput.value) + 1;
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });

      // Decrease the quantity input value, making sure it doesn't go below 1
      minusBtn.addEventListener("click", () => {
        let newQty = Math.max(1, parseInt(qtyInput.value) - 1); // Prevent going below 1
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });
    });
  }
}

/**
 * Sends a request to the Ajax API to update the quantity of the line item.
 */

function updateItemQuantity(lineKey, value, qtyInput) {
  const subscriptionStates = captureSubscriptionStates();

  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: parseInt(value),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data?.status === 422) {
        const miniCartItem = document.querySelector(
          `.mini-cart__item[data-line-key="${lineKey}"]`
        );
        let errorMsg = miniCartItem.querySelector(".error-message");

        errorMsg.textContent = data.message;

        qtyInput.value = qtyInput.getAttribute("data-prev-value");
        return;
      }

      document
        .querySelectorAll(".error-message")
        .forEach((msg) => msg.remove());

      renderCart(data).then(() => {
        // Restore subscription states after re-render
        restoreSubscriptionStates(subscriptionStates);
      });
    })
    .catch((err) => console.error("Cart update failed:", err));
}

/**
 * Sends a request to the Ajax api, updating the selected items quantity
 * to 0, which will remove it from the cart.
 */

function handleRemoveItem(lineKey, value) {
  const removeItemButton = document.querySelectorAll(".item__remove");

  removeItemButton.forEach((button) => {
    // Remove any existing event listeners to prevent duplicates
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Get the line item key from the buttons data attribute
    let lineKey = newButton.dataset.lineKey;

    newButton.addEventListener("click", () => {
      const miniCartItem = document.querySelector(`.mini-cart__item[data-line-key="${lineKey}"]`);
      const isGwpLineItem = !!(miniCartItem && miniCartItem.querySelector('.product-price[data-gwp-item="true"]'));
      if (isGwpLineItem) {
        // Respect explicit user intent: if user manually removes GWP, do not auto-add again
        // until the milestone state is reset below threshold.
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            if (!cartData || !Array.isArray(cartData.items)) return;
            const matchedItem = cartData.items.find((item) => item.key === lineKey);
            if (matchedItem && matchedItem.variant_id) {
              markGwpAutoAddDismissed(matchedItem.variant_id);
            }
          })
          .catch(() => {});
      }
      // Update the item quantity to 0 in the cart to remove it
      updateItemQuantity(lineKey, 0);
    });
  });
}

/**
 * Handle removing all cart items
 */
const removeAllButton = document.querySelector(".mini-cart__remove-all");
if (removeAllButton) {
  removeAllButton.addEventListener("click", () => {
    fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "post",
    })
      .then((response) => response.json())
      .then((data) => {
        renderCart(data);
      });
  });
}

/**
 * Event listener for mini-cart-open event triggered by Vue.js components
 * This ensures the cart is properly rendered with sale tags when items are added via quick-add-to-cart buttons
 */
document.body.addEventListener("mini-cart-open", async (event) => {
  
  // Capture current subscription states before re-rendering
  const subscriptionStates = captureSubscriptionStates();
  
  // If cart data is provided in the event detail, use it to render the cart
  if (event.detail && event.detail.items) {
    await renderCart(event.detail);
    // Restore subscription states after rendering
    restoreSubscriptionStates(subscriptionStates);
  } else {
    // Otherwise, fetch the current cart data and render it
    // Add a small delay to ensure cart data is fresh
    setTimeout(() => {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          renderCart(cartData).then(() => {
            // Restore subscription states after rendering
            restoreSubscriptionStates(subscriptionStates);
          });
        })
        .catch((err) => console.error("Cart update failed:", err));
    }, 100);
  }
  
  // Open the mini cart
  overlay.classList.add("overlay--show");
  miniCart.classList.add("mini-cart--show");
  document.body.style.overflow = 'hidden';
  miniCartFooter.style.display = "none";
});

/**
 * Check if a product should have GWP or Final Sale properties and add them if missing
 * This ensures that items added via Vue.js components get the same properties as items added via the product form
 */
function addMissingProperties(cartData) {
  
      if (!cartData || !cartData.items) {
      return cartData;
    }
  
  // Create a copy of the cart data to modify
  const modifiedCartData = JSON.parse(JSON.stringify(cartData));
  
  // Process each item to check for product tags
  const processItems = async () => {
    for (let item of modifiedCartData.items) {
      // Check if the item already has GWP or Final Sale properties
      const hasGwpProperty = item.properties && (
        item.properties["_gwp_nc"] === "1" || 
        item.properties["_gift_for_purchase"] === "true" ||
        item.properties["Note"] && item.properties["Note"].includes("GWP")
      );
      
      const hasFinalSaleProperty = item.properties && (
        item.properties["Note"] === "Final Sale" || 
        item.properties["_Note"] === "Final Sale"
      );
      
      if (!hasGwpProperty && !hasFinalSaleProperty) {
        // Initialize properties if they don't exist
        if (!item.properties) {
          item.properties = {};
        }
        
        try {
          // Fetch product data from Shopify to get the actual tags
          const productResponse = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`);
          const productData = await productResponse.json();
          
          // Check if product has GWP or Final Sale tags
          const productTags = productData.tags || [];
          const hasGwpTag = productTags.some(tag => 
            tag.toLowerCase().includes('gwp') || 
            tag.toLowerCase().includes('gift') || 
            tag.toLowerCase().includes('free')
          );
          const hasFinalSaleTag = productTags.some(tag => 
            tag.toLowerCase().includes('final sale') || 
            tag.toLowerCase().includes('final-sale') ||
            tag.toLowerCase().includes('flash sale') ||
            tag.toLowerCase().includes('flash-sale')
          );
          
          if (hasGwpTag) {
            // Set properties that Vue.js cart-item component expects
            item.properties["_gwp_nc"] = "1";
            item.properties["_gift_for_purchase"] = "true";
            item.properties["Note"] = "Discount applied at next step";
          } else if (hasFinalSaleTag) {
            item.properties["Note"] = "Final Sale";
          }
          
        } catch (error) {
        }
      }
    }
    
    return modifiedCartData;
  };
  
  // Return a promise that resolves with the processed cart data
  return processItems();
}

const productDataCache = {};

  // check if a product/variant has selling plans
  async function hasSellingPlan(item) {
  if (!item.handle) {
    return false;
  }

  // Helper to build intervalOptions from ALL groups
  const buildIntervalOptions = (productData) => {
    const groups = Array.isArray(productData.selling_plan_groups)
      ? productData.selling_plan_groups
      : [];

    const allPlans = groups.reduce((acc, group) => {
      if (group && Array.isArray(group.selling_plans)) {
        return acc.concat(group.selling_plans);
      }
      return acc;
    }, []);

    return allPlans.map((plan) => ({
      label: plan.name, // e.g. "Delivery every 45 days"
      value: plan.id,
    }));
  };

  // Use cache if we already fetched this product
  if (productDataCache[item.handle]) {
    const productData = productDataCache[item.handle];

    if (!productData.intervalOptions) {
      productData.intervalOptions = buildIntervalOptions(productData);
    }

    const eligible =
      Array.isArray(productData.selling_plan_groups) &&
      productData.selling_plan_groups.length > 0;

    return eligible;
  }

  // Otherwise fetch product JSON and cache it
  try {
    const productData = await fetch(
      `${window.Shopify.routes.root}products/${item.handle}.js`
    ).then((res) => res.json());

    productData.intervalOptions = buildIntervalOptions(productData);
    productDataCache[item.handle] = productData;

    const eligible =
      Array.isArray(productData.selling_plan_groups) &&
      productData.selling_plan_groups.length > 0;

    return eligible;
  } catch (e) {
    return false;
  }
  }

  function addEligibilityCSS() {
    if (!document.getElementById('subscription-eligibility-css')) {
      const style = document.createElement('style');
      style.id = 'subscription-eligibility-css';
      style.textContent = `
        .mini-cart__item[data-subscription-eligible="false"] .subscribe-save-cart-ui {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

// Update fetch interceptors and event listeners to use async/await with renderCart
// Intercept cart API calls to ensure renderCart is called

document.addEventListener('DOMContentLoaded', function() {
  // Override fetch to intercept cart API calls
  const originalFetch = window.fetch;
  window.fetch = async function(url, options) {
    // Check if this is a cart-related API call
    if (url && (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js'))) {
      const response = await originalFetch.apply(this, arguments);
      // Clone the response so we can read it
      const clonedResponse = response.clone();
      try {
        const data = await clonedResponse.json();
        // Only call renderCart with a full cart (has .items array). cart/add.js returns the added item, not the full cart.
        if (data && Array.isArray(data.items)) {
          await renderCart(data);
        }
      } catch (err) {}
      return response;
    }
    return originalFetch.apply(this, arguments);
  };

  // Intercept XMLHttpRequest for cart/change.js and cart/update.js (used by Vue cart-grid via nanoajax).
  // On success, fetch full cart and update main cart sidebar subtotal so GWP is excluded without refresh.
  (function() {
    if (window._cartXHRInterceptorInstalled) return;
    window._cartXHRInterceptorInstalled = true;
    var OriginalXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function() {
      var xhr = new OriginalXHR();
      var originalOpen = xhr.open;
      xhr.open = function(method, url) {
        xhr._cartUrl = (typeof url === "string" && (url.indexOf("cart/change.js") !== -1 || url.indexOf("cart/update.js") !== -1)) ? url : null;
        return originalOpen.apply(this, arguments);
      };
      xhr.addEventListener("load", function() {
        if (xhr.status !== 200 || !xhr._cartUrl || !document.querySelector(".cart-grid--default")) return;
        if (typeof updateMainCartSidebarSubtotal !== "function" && typeof refreshMainCartVueState !== "function") return;
        fetch(window.Shopify.routes.root + "cart.js")
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (typeof updateMainCartSidebarSubtotal === "function") {
              updateMainCartSidebarSubtotal(cart);
              setTimeout(function() { updateMainCartSidebarSubtotal(cart); }, 150);
            }
            if (typeof refreshMainCartVueState === "function") refreshMainCartVueState(cart);
          })
          .catch(function() {});
      });
      return xhr;
    };
  })();

  // Also watch for changes to the cart count in the header
  const cartCountElement = document.querySelector('.nav__cart-count span');
  if (cartCountElement) {
    const observer = new MutationObserver(async function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          try {
            const response = await fetch(window.Shopify.routes.root + "cart.js");
            const cartData = await response.json();
            await renderCart(cartData);
          } catch (err) {
            console.error("Cart update failed:", err);
          }
        }
      }
    });
    observer.observe(cartCountElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
});

// Global event listener to catch all events for debugging
document.addEventListener('DOMContentLoaded', function() {
  
  // Listen for all events
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (type === 'click' || type === 'submit' || type.includes('cart') || type.includes('add')) {
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
  
  // Listen for custom events
  document.addEventListener('*', function(event) {
  });
  
  // Listen for specific events that might be related to cart
  ['cart:updated', 'cart:added', 'mini-cart-open', 'cart-updated', 'cart-added'].forEach(eventType => {
    document.addEventListener(eventType, function(event) {
    });
  });
});

// Watch for Vue.js mini-cart opening and trigger our cart rendering
document.addEventListener('DOMContentLoaded', function() {
  
  // Watch for mini-cart element
  const miniCartElement = document.querySelector('mini-cart');
  if (miniCartElement) {
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const classList = miniCartElement.classList;
          if (classList.contains('mini-cart--open')) {
            
            // Fetch current cart and render with our logic
            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cartData) => {
                renderCart(cartData);
              })
              .catch((err) => console.error("Cart update failed:", err));
          }
        }
      });
    });
    
    observer.observe(miniCartElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Also watch for any element with mini-cart--open class
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('mini-cart--open')) {
            
            // Fetch current cart and render with our logic
            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cartData) => {
                renderCart(cartData);
              })
              .catch((err) => console.error("Cart update failed:", err));
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Main cart page: patch Vuex store so refreshCart never receives a line-item payload (from cart/change.js), which would remove GWP
  if (document.querySelector(".cart-grid--default") && typeof patchMainCartStoreOnce === "function") {
    [400, 800, 1500].forEach(function (delay) {
      setTimeout(function () {
        var root = document.querySelector(".cart-grid--default");
        var parent = root && root.closest ? root.closest("[data-module='cart-grid']") : null;
        var vueInstance = (root && root.__vue__) || (parent && parent.__vue__);
        if (vueInstance && vueInstance.$store) patchMainCartStoreOnce(vueInstance.$store);
      }, delay);
    });
  }
  // Main cart page: run GWP sync at 600ms, 1200ms, 1800ms so we catch Vue after mount and keep GWP visible
  if (document.querySelector(".cart-grid--default") && typeof syncMainCartGwpFromMilestone === "function") {
    setTimeout(syncMainCartGwpFromMilestone, 600);
    setTimeout(syncMainCartGwpFromMilestone, 1200);
    setTimeout(syncMainCartGwpFromMilestone, 1800);
  }
});

var _mainCartGwpSyncTimeout = null;
document.addEventListener("cart:updated", function() {
  if (!document.querySelector(".cart-grid--default") || typeof syncMainCartGwpFromMilestone !== "function") return;
  clearTimeout(_mainCartGwpSyncTimeout);
  _mainCartGwpSyncTimeout = setTimeout(syncMainCartGwpFromMilestone, 400);
});

// Rebuy Custom code - update mini cart on click
function setupRebuyButtonHandlers() {
  document.addEventListener('rebuy:loaded', function () {
    attachRebuyButtonListeners();
  });
  
  let pollCount = 0;
  const maxPolls = 20;
  const pollInterval = setInterval(() => {
    pollCount++;
    const targetWidget = document.querySelector('[data-rebuy-id="231166"]');
    if (targetWidget) {
      clearInterval(pollInterval);
      attachRebuyButtonListeners();
    } else if (pollCount >= maxPolls) {
      clearInterval(pollInterval);
      attachRebuyButtonListenersAlternative();
    }
  }, 500);
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector) {
            const targetWidget = node.querySelector('[data-rebuy-id="231166"]') || 
                               (node.matches('[data-rebuy-id="231166"]') ? node : null);
            if (targetWidget) {
              attachRebuyButtonListeners();
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function attachRebuyButtonListeners() {
  const targetWidget = document.querySelector('[data-rebuy-id="231166"]');
  
  if (!targetWidget) {
    return;
  }
  
  setTimeout(() => {
    const buttonSelectors = [
      '.rebuy-button',
      'button.rebuy-button',
      '[data-rebuy-action="add-to-cart"]',
      'button[data-rebuy-action="add-to-cart"]',
      'button[data-rebuy-action]',
      '.rebuy-widget button',
      '.rebuy-product-block button',
      'button'
    ];
    
    let buttonsFound = 0;
    
    buttonSelectors.forEach(selector => {
      const buttons = targetWidget.querySelectorAll(selector);
      if (buttons.length > 0) {
        buttonsFound += buttons.length;
        
        buttons.forEach(button => {
          // Skip if button already has our listener
          if (button.hasAttribute('data-rebuy-handled')) {
            return;
          }
          
          const productBlock = button.closest('.rebuy-product-block');
          
          const buttonText = button.textContent.toLowerCase();
          const isAddToCartButton = buttonText.includes('add') ||
                                   buttonText.includes('cart') ||
                                   buttonText.includes('buy') ||
                                   button.getAttribute('data-rebuy-action') === 'add-to-cart' ||
                                   button.classList.contains('rebuy-button') ||
                                   button.classList.contains('add-to-cart');
          
          if (isAddToCartButton) {
            // Remove any existing listeners first
            button.removeEventListener('click', handleRebuyButtonClick, true);
            button.removeEventListener('click', handleRebuyButtonClick, false);
            
            // Add our listener
            button.addEventListener('click', handleRebuyButtonClick, true);
            
            // Mark as handled to prevent duplicates
            button.setAttribute('data-rebuy-handled', 'true');
          }
        });
      }
    });
    
    if (buttonsFound === 0) {
      attachRebuyButtonListenersAlternative();
    }
  }, 1000);
}

function attachRebuyButtonListenersAlternative() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button');
    if (!button) return;
    
    const rebuyWidget = button.closest('[data-rebuy-id="231166"]');
    if (!rebuyWidget) return;
    
    const buttonText = button.textContent.toLowerCase();
    const isAddToCartButton = buttonText.includes('add') ||
                             buttonText.includes('cart') ||
                             buttonText.includes('buy') ||
                             button.getAttribute('data-rebuy-action') === 'add-to-cart' ||
                             button.classList.contains('rebuy-button') ||
                             button.classList.contains('add-to-cart');
    
    if (isAddToCartButton) {
      handleRebuyButtonClick(e);
    }
  }, true);
}

function handleRebuyButtonClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const button = e.target;
  
  // Prevent duplicate clicks while processing
  if (button.hasAttribute('data-processing')) {
    return;
  }
  
  // Mark as processing
  button.setAttribute('data-processing', 'true');
  
  const productBlock = button.closest('.rebuy-product-block');
  let productId = null;
  let variantId = null;
  
  if (productBlock) {
    productId = productBlock.getAttribute('data-rebuy-product-id') || 
                productBlock.querySelector('[data-rebuy-product-id]')?.getAttribute('data-rebuy-product-id');
    
    variantId = productBlock.getAttribute('data-rebuy-variant-id') ||
                button.getAttribute('data-rebuy-variant-id') ||
                productBlock.querySelector('[data-rebuy-variant-id]')?.getAttribute('data-rebuy-variant-id');
    
    if (!variantId) {
      const productLink = productBlock.querySelector('a[href*="variant="]');
      if (productLink) {
        const url = new URL(productLink.href);
        const variantParam = url.searchParams.get('variant');
        if (variantParam) {
          variantId = variantParam;
        }
      }
    }
    
    if (!variantId) {
      const productClass = productBlock.className;
      const variantMatch = productClass.match(/variant-(\d+)/);
      if (variantMatch) {
        variantId = variantMatch[1];
      }
    }
    
    if (!variantId) {
      const allElements = productBlock.querySelectorAll('[data-*]');
      for (const element of allElements) {
        const attributes = element.attributes;
        for (const attr of attributes) {
          if (attr.name.includes('variant') && attr.value) {
            variantId = attr.value;
            break;
          }
        }
        if (variantId) break;
      }
    }
  }
  
  if (variantId) {
    addProductToCart(variantId, button);
  } else {
    openMiniCart();
  }
  
  const cartChangeHandler = function() {
    document.removeEventListener('rebuy:cart.change', cartChangeHandler);
    ensureMiniCartOpen();
  };
  
  document.addEventListener('rebuy:cart.change', cartChangeHandler);
  
  const alternativeEvents = ['cart:updated', 'cart:added', 'cart-updated', 'cart-added'];
  alternativeEvents.forEach(eventType => {
    const alternativeHandler = function() {
      document.removeEventListener(eventType, alternativeHandler);
      ensureMiniCartOpen();
    };
    document.addEventListener(eventType, alternativeHandler);
  });
  
  try {
    const originalClick = button.onclick;
    if (originalClick) {
      originalClick.call(button, e);
    }
  } catch (error) {
  }
}

async function addProductToCart(variantId, button) {
  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;
  
  try {
    // Quick check to see if this variant is already being added
    if (window.addingVariants && window.addingVariants.includes(variantId)) {
      console.log('Variant already being added:', variantId);
      return;
    }
    
    // Track this variant as being added
    if (!window.addingVariants) window.addingVariants = [];
    window.addingVariants.push(variantId);
    
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cartData = await response.json();
    
    await renderCart(cartData);
    
    openMiniCart();
    
    document.dispatchEvent(new Event('cart:updated'));
    
  } catch (error) {
    button.textContent = 'Error - Try Again';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
    
    openMiniCart();
  } finally {
    button.textContent = originalText;
    button.disabled = false;
    // Remove processing flag to allow future clicks
    button.removeAttribute('data-processing');
    // Remove variant from tracking
    if (window.addingVariants) {
      const index = window.addingVariants.indexOf(variantId);
      if (index > -1) {
        window.addingVariants.splice(index, 1);
      }
    }
  }
}

function ensureMiniCartOpen() {
  if (!document.documentElement.classList.contains('mini-cart--show')) {
    openMiniCart();
  }
}

setupRebuyButtonHandlers();

// Rebuy Widget: Add to bag button append in media
document.addEventListener('DOMContentLoaded', function() {
  function checkAndMoveActions() {
    const widgetContainer = document.querySelector('[data-rebuy-id="231166"]');
    
    if (widgetContainer) {
      const productBlocks = widgetContainer.querySelectorAll('.rebuy-product-block');
      
      if (productBlocks.length > 0) {
        productBlocks.forEach(function(block, index) {
          const productMedia = block.querySelector('.rebuy-product-media');
          const productActions = block.querySelector('.rebuy-product-actions');

          if (productMedia && productActions) {
            productMedia.appendChild(productActions);
          }
        });
        
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  
  let attempts = 0;
  const maxAttempts = 20;
  const checkInterval = setInterval(() => {
    attempts++;
    
    if (checkAndMoveActions() || attempts >= maxAttempts) {
      clearInterval(checkInterval);
    }
  }, 500);
});